(function() {
  "use strict";
  const isLocalDev = window.location.hostname.includes("replit") || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const API_BASE = isLocalDev ? window.location.origin : "https://smokeai.chat";
  const API_ENDPOINT = API_BASE + "/api/cannabis-ai/query";
  const HEALTH_ENDPOINT = API_BASE + "/api/cannabis-ai/health";
  const INIT_ENDPOINT = API_BASE + "/api/shopify/widget/init";
  const WIDGET_VERSION = "4.1-agegate";
  var _scriptEl = document.currentScript || document.querySelector("script[data-partner-id]") || (function() {
    var scripts = document.querySelectorAll("script[src]");
    for (var i = scripts.length - 1; i >= 0; i--) {
      if (scripts[i].src && (scripts[i].src.includes("/widget.js") || scripts[i].src.includes("/shopify-widget.js"))) {
        return scripts[i];
      }
    }
    return null;
  })();
  var _d = _scriptEl && _scriptEl.dataset ? _scriptEl.dataset : {};
  var config = Object.assign(
    {
      partnerId: _d.partnerId || null,
      apiKey: _d.apiKey || null,
      shopDomain: _d.shopDomain || null,
      position: _d.position || null,
      buttonColor: _d.primaryColor || null,
      // data-primary-color → buttonColor
      buttonText: _d.buttonText || null,
      showAddToCart: _d.showAddToCart !== void 0 ? _d.showAddToCart === "true" : void 0
    },
    window.SmokeAIConfig || window.SMOKE_AI_CONFIG || {}
  );
  function getShopDomain() {
    if (config.shopDomain) return config.shopDomain;
    if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    var hostname = window.location.hostname;
    if (hostname.endsWith(".myshopify.com")) return hostname;
    if (hostname === "weedcommerce.co" || hostname === "www.weedcommerce.co") return hostname;
    var shopifyMeta = document.querySelector('meta[name="shopify-checkout-api-token"]');
    if (shopifyMeta) return hostname;
    if (window.Shopify) return hostname;
    return hostname;
  }
  const shopDomain = getShopDomain();
  const IS_WEEDCOMMERCE_DOMAIN = window.location.hostname === "weedcommerce.co" || window.location.hostname.endsWith(".weedcommerce.co");
  function detectProductImage() {
    if (config.productImage) return config.productImage;
    if (window.Shopify && window.Shopify.product) {
      const shopifyProduct = window.Shopify.product;
      if (shopifyProduct.featured_image) return shopifyProduct.featured_image;
      if (shopifyProduct.images && shopifyProduct.images.length > 0) {
        return shopifyProduct.images[0];
      }
    }
    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage && ogImage.content) return ogImage.content;
    const twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (twitterImage && twitterImage.content) return twitterImage.content;
    const imageSelectors = [
      ".product__media img",
      ".product-single__photo img",
      ".product-featured-img",
      ".product-image-main img",
      "[data-product-featured-image]",
      ".product__main-photos img",
      ".product-gallery__image img",
      ".featured-image img",
      ".product-main-image img"
    ];
    for (const selector of imageSelectors) {
      const img = document.querySelector(selector);
      if (img && (img.src || img.dataset.src)) {
        return img.src || img.dataset.src;
      }
    }
    return "";
  }
  const productInfo = {
    handle: config.productHandle || window.Shopify && window.Shopify.product && window.Shopify.product.handle || "",
    id: config.productId || window.Shopify && window.Shopify.product && window.Shopify.product.id || "",
    title: config.productTitle || window.Shopify && window.Shopify.product && window.Shopify.product.title || "",
    type: config.productType || window.Shopify && window.Shopify.product && window.Shopify.product.type || "",
    vendor: config.productVendor || window.Shopify && window.Shopify.product && window.Shopify.product.vendor || "",
    image: detectProductImage(),
    variantId: config.productVariantId || "",
    price: config.productPrice || ""
  };
  const settings = {
    buttonText: config.buttonText || "Smoke AI",
    logoUrl: config.logoUrl || null,
    storeLogo: config.storeLogo || null,
    // Custom store logo for white-label (Growth+ only)
    buttonColor: config.buttonColor || config.primaryColor || "#10b981",
    position: config.position || "bottom-right",
    showOnAllProducts: config.showOnAllProducts !== false,
    isInline: config.position === "inline",
    bubbleMode: config.bubbleMode === true,
    inventoryOnly: config.inventoryOnly === true,
    shopName: config.shopName || "",
    productCatalog: config.productCatalog || null,
    // Allow direct product catalog injection for testing
    whiteLabelEnabled: config._testWhiteLabel === true,
    // Only for test pages - production uses server response
    hideAgeDisclaimer: false
    // White-label Growth+ can disable the 21+ disclaimer (e.g. they have their own age gate)
  };
  let storeProducts = config.storeProducts || [];
  const WEEDCOMMERCE_AVATAR = API_BASE + "/api/assets/smoke-ai-mascot-logo.png";
  function getB2BAvatar() {
    const color = settings.buttonColor.replace("#", "%23");
    return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"%3E%3Ccircle cx="24" cy="24" r="24" fill="' + color + '"/%3E%3Crect x="14" y="22" width="20" height="14" rx="2" fill="white"/%3E%3Cpath d="M12 22 L24 12 L36 22" stroke="white" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/%3E%3Crect x="21" y="28" width="6" height="8" fill="' + color + '"/%3E%3C/svg%3E';
  }
  function getAvatarImage() {
    if (settings.logoUrl) {
      return settings.logoUrl;
    }
    if (settings.whiteLabelEnabled) {
      if (settings.storeLogo) {
        return settings.storeLogo;
      }
    }
    return WEEDCOMMERCE_AVATAR;
  }
  function updateBrandingDisplay() {
    try {
      const disclaimerEl = document.querySelector(".smoke-ai-disclaimer");
      if (!disclaimerEl) return;
      const hasCustomBranding = settings.whiteLabelEnabled && settings.storeName;
      if (settings.hideAgeDisclaimer && hasCustomBranding) {
        disclaimerEl.innerHTML = "";
      } else if (hasCustomBranding) {
        disclaimerEl.innerHTML = "<strong>21+</strong> \u2022 Educational only \u2022 Not medical advice";
      } else {
        disclaimerEl.innerHTML = `
          <strong>21+</strong> \u2022 Educational only \u2022 Not medical advice
          <br><a href="https://smokeai.chat/terms-of-service" target="_blank">View Full Terms</a>
          <div style="margin-top: 4px; font-size: 9px; color: #9ca3af;">Powered by Weedcommerce</div>
        `;
      }
      const newAvatar = getAvatarImage();
      const headerIcon = document.querySelector(".smoke-ai-header-icon");
      if (headerIcon) {
        headerIcon.src = newAvatar;
      }
      const buttonImg = document.querySelector("#smoke-ai-widget img");
      if (buttonImg) {
        buttonImg.src = newAvatar;
      }
      const botAvatars = document.querySelectorAll(".smoke-ai-bot-avatar");
      botAvatars.forEach(function(avatar) {
        avatar.src = newAvatar;
      });
    } catch (e) {
      console.warn("Branding update error:", e);
    }
  }
  let serverIsWarm = false;
  let warmupInProgress = false;
  let warmupStartTime = null;
  let quotaInfo = {
    planType: "trial",
    monthlyQuota: 50,
    questionsUsedThisMonth: 0,
    questionsRemaining: 50,
    isB2B: false
    // Will be set from server response or config
  };
  function updateWarmupStatus(message) {
    const statusBar = document.getElementById("smoke-ai-status");
    if (statusBar) {
      statusBar.innerHTML = message;
      statusBar.style.background = warmupInProgress ? "#1e3a5f" : "#334155";
    }
  }
  function updateQuotaStatus() {
    const statusBar = document.getElementById("smoke-ai-status");
    if (!statusBar) return;
    if (quotaInfo.isB2B) {
      if (quotaInfo.questionsRemaining <= 0) {
        statusBar.innerHTML = "\u26A0\uFE0F Service temporarily unavailable";
        statusBar.style.background = "#7f1d1d";
        statusBar.style.display = "block";
      } else {
        statusBar.style.display = "none";
      }
      return;
    }
    statusBar.style.display = "none";
  }
  (function preWarmServer() {
    warmupInProgress = true;
    warmupStartTime = Date.now();
    console.log("\u{1F525} Pre-warming server...");
    const warmUp = async (attempt = 1) => {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 6e4);
        const response = await fetch(API_BASE + "/api/cannabis-ai/health", {
          method: "GET",
          mode: "cors",
          signal: controller.signal,
          cache: "no-store"
        });
        clearTimeout(timeoutId);
        if (response.ok) {
          serverIsWarm = true;
          warmupInProgress = false;
          const warmupTime = ((Date.now() - warmupStartTime) / 1e3).toFixed(1);
          console.log("\u2705 Server is warm and ready! (attempt " + attempt + ", took " + warmupTime + "s)");
          if (quotaInfo.isB2B) {
            updateQuotaStatus();
          } else {
            const statusBar = document.getElementById("smoke-ai-status");
            if (statusBar) statusBar.style.display = "none";
          }
          return;
        }
      } catch (e) {
        const elapsed = ((Date.now() - warmupStartTime) / 1e3).toFixed(0);
        console.log("\u23F3 Server warming up... (attempt " + attempt + ", " + elapsed + "s elapsed)");
        updateWarmupStatus("\u23F3 Connecting to AI... (this may take up to 60s after idle periods)");
      }
      if (attempt < 8) {
        const delay = Math.min(3e3 + attempt * 2e3, 15e3);
        setTimeout(() => warmUp(attempt + 1), delay);
      } else {
        warmupInProgress = false;
        console.log("\u26A0\uFE0F Pre-warm attempts exhausted, will try on user action");
        updateWarmupStatus("\u26A0\uFE0F Connection slow - will retry when you ask a question");
      }
    };
    warmUp();
  })();
  const AVATAR_FALLBACK = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"%3E%3Ccircle cx="16" cy="16" r="16" fill="%2310b981"/%3E%3Ctext x="16" y="22" text-anchor="middle" fill="white" font-size="20"%3E\u{1F33F}%3C/text%3E%3C/svg%3E';
  let connectionStatus = "checking";
  let lastError = null;
  const SESSION_KEY = "smoke_ai_session_v4";
  const SECRET_KEY = "smoke_ai_secret_" + shopDomain;
  const TERMS_KEY = "smoke_ai_terms_accepted";
  const PRODUCTS_CACHE_KEY = IS_WEEDCOMMERCE_DOMAIN ? "smoke_ai_products_glass_focus_v1" : "smoke_ai_products_cache";
  const QUOTA_KEY = "smoke_ai_quota_" + shopDomain;
  let sessionId = localStorage.getItem(SESSION_KEY);
  let shopSecret = localStorage.getItem(SECRET_KEY);
  let termsAccepted = localStorage.getItem(TERMS_KEY) === "true" || config.skipDisclaimer === true;
  let pendingQuestion = null;
  quotaInfo.isB2B = settings.inventoryOnly || config.isB2B || false;
  try {
    const cachedQuota = localStorage.getItem(QUOTA_KEY);
    if (cachedQuota) {
      const cached = JSON.parse(cachedQuota);
      quotaInfo = { ...quotaInfo, ...cached };
    }
  } catch (e) {
  }
  if (!sessionId || !sessionId.startsWith("shopify_widget_")) {
    sessionId = "shopify_widget_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
    localStorage.setItem(SESSION_KEY, sessionId);
  }
  console.log("\u{1F33F} Smoke AI Widget v" + WIDGET_VERSION + " loading...", {
    api: API_BASE,
    shop: shopDomain,
    hostname: window.location.hostname,
    isWeedcommerceDomain: IS_WEEDCOMMERCE_DOMAIN,
    teaserShown: !!localStorage.getItem("smoke_ai_teaser_shown"),
    gateSeen: !!sessionStorage.getItem("smoke_ai_gate_seen"),
    session: sessionId.substring(0, 20) + "...",
    timestamp: (/* @__PURE__ */ new Date()).toISOString()
  });
  if (productInfo.title || productInfo.image) {
    console.log("\u{1F6CD}\uFE0F Product detected:", {
      title: productInfo.title || "(none)",
      image: productInfo.image ? productInfo.image.substring(0, 80) + "..." : "(none)",
      handle: productInfo.handle || "(none)"
    });
  }
  async function fetchWithRetry(url, options, maxRetries = 5) {
    let lastError2;
    let corsFailureCount = 0;
    const isQueryEndpoint = url.includes("/query");
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const controller = new AbortController();
        const timeoutMs = isQueryEndpoint ? 9e4 : 6e4;
        const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
        console.log("\u{1F33F} Smoke AI request attempt " + attempt + "/" + maxRetries + " to " + url.split("/").pop());
        const response = await fetch(url, {
          ...options,
          mode: "cors",
          // Explicitly request CORS
          signal: controller.signal
        });
        clearTimeout(timeoutId);
        if (response.ok) {
          console.log("\u2705 Smoke AI request succeeded on attempt " + attempt);
          return response;
        }
        if (response.status >= 400 && response.status < 500 && response.status !== 429 && response.status !== 403) {
          const errorText = await response.text().catch(() => "Unknown error");
          console.error("\u274C API error " + response.status + ":", errorText);
          let friendlyMsg = "API error " + response.status;
          try {
            const errJson = JSON.parse(errorText);
            if (errJson.message) friendlyMsg = errJson.message;
            else if (errJson.error) friendlyMsg = errJson.error;
          } catch (e) {
            if (errorText && errorText.length < 200) friendlyMsg = errorText;
          }
          lastError2 = new Error(friendlyMsg);
          break;
        }
        if (response.status === 403) {
          corsFailureCount++;
          console.warn("\u26A0\uFE0F Got 403 - may be CORS preflight issue, retrying...");
        }
        lastError2 = new Error("HTTP " + response.status);
        console.warn("\u26A0\uFE0F Request failed with status " + response.status + ", will retry...");
      } catch (err) {
        lastError2 = err;
        if (err.name === "AbortError") {
          lastError2 = new Error("Request timeout - server may be starting up after overnight idle");
          console.warn("\u23F1\uFE0F Request timed out, server may be cold starting (this can take 60s+ after idle)...");
          updateWarmupStatus("\u23F3 Server waking up... please wait");
        } else if (err.name === "TypeError" && (err.message.includes("Failed to fetch") || err.message.includes("NetworkError") || err.message.includes("Load failed"))) {
          corsFailureCount++;
          lastError2 = new Error("Network/CORS error - retrying...");
          console.warn("\u{1F310} Network/CORS error (attempt " + attempt + "): " + err.message);
        } else {
          console.warn("\u26A0\uFE0F Request error:", err.message);
        }
      }
      if (attempt < maxRetries) {
        const baseDelay = corsFailureCount > 0 ? 3e3 : 2e3;
        const delay = Math.min(baseDelay * Math.pow(1.5, attempt - 1), 1e4);
        console.log("\u{1F504} Retry " + attempt + "/" + maxRetries + " in " + (delay / 1e3).toFixed(1) + "s...");
        await new Promise((r) => setTimeout(r, delay));
      }
    }
    let errorMessage = "Unable to connect to Smoke AI";
    if (corsFailureCount > 0) {
      errorMessage = "Connection blocked - please refresh the page and try again";
    } else if (lastError2 && (lastError2.message.includes("timeout") || lastError2.message.includes("starting up"))) {
      errorMessage = "Server is waking up after being idle - please wait 30-60 seconds and try again";
    } else if (lastError2 && lastError2.message && !lastError2.message.startsWith("HTTP ") && !lastError2.message.includes("Network/CORS")) {
      errorMessage = lastError2.message;
    }
    console.error("\u274C All attempts failed:", lastError2 ? lastError2.message : "unknown");
    updateWarmupStatus("\u26A0\uFE0F " + errorMessage);
    throw new Error(errorMessage);
  }
  async function generateSignature(bodyStr, timestamp) {
    if (!shopSecret || !shopDomain) return null;
    try {
      const message = shopDomain + "|" + timestamp + "|" + bodyStr;
      const encoder = new TextEncoder();
      const keyData = encoder.encode(shopSecret);
      const msgData = encoder.encode(message);
      const cryptoKey = await crypto.subtle.importKey(
        "raw",
        keyData,
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
      );
      const sig = await crypto.subtle.sign("HMAC", cryptoKey, msgData);
      return Array.from(new Uint8Array(sig)).map((b) => b.toString(16).padStart(2, "0")).join("");
    } catch (e) {
      console.warn("Signature error:", e);
      return null;
    }
  }
  async function initAuth() {
    if (!shopDomain) return;
    if (shopSecret) {
      console.log("\u2705 Using cached auth secret");
      updateQuotaStatus();
      return;
    }
    try {
      const res = await fetchWithRetry(INIT_ENDPOINT, {
        method: "POST",
        mode: "cors",
        // Explicit CORS for cross-origin
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          shopDomain,
          partnerId: config.partnerId || null,
          apiKey: config.apiKey || null
        })
      }, 2);
      const data = await res.json();
      if (data.secret) {
        if (data.statelessMode || data.secret.startsWith("STATELESS_MODE_")) {
          console.log("\u2139\uFE0F Server in stateless mode, using session-only auth");
          shopSecret = null;
        } else {
          shopSecret = data.secret;
          localStorage.setItem(SECRET_KEY, shopSecret);
          console.log("\u2705 Widget authenticated");
        }
      }
      if (data.quota) {
        quotaInfo = {
          planType: data.quota.planType || "trial",
          monthlyQuota: data.quota.monthlyQuota || 50,
          questionsUsedThisMonth: data.quota.questionsUsedThisMonth || 0,
          questionsRemaining: data.quota.questionsRemaining || 50,
          isB2B: data.quota.inventoryOnly === true
          // Server is authoritative for B2B mode
        };
        settings.inventoryOnly = data.quota.inventoryOnly === true;
        settings.isB2B = data.quota.inventoryOnly === true;
        if (!config._testWhiteLabel) {
          settings.whiteLabelEnabled = data.quota.whiteLabelEnabled === true;
        }
        if (data.quota.welcomeMessage) {
          settings.welcomeMessage = data.quota.welcomeMessage;
        }
        if (data.quota.searchPlaceholder) {
          settings.searchPlaceholder = data.quota.searchPlaceholder;
        }
        if (data.quota.storeName) {
          settings.storeName = data.quota.storeName;
        }
        if (data.quota.storeLogo) {
          settings.storeLogo = data.quota.storeLogo;
        }
        if (data.quota.hideAgeDisclaimer !== void 0) {
          settings.hideAgeDisclaimer = data.quota.hideAgeDisclaimer === true;
        }
        settings.showAddToCart = data.quota.showAddToCart !== false;
        localStorage.setItem(QUOTA_KEY, JSON.stringify(quotaInfo));
        console.log("\u{1F4CA} B2B Quota:", quotaInfo.questionsRemaining + "/" + quotaInfo.monthlyQuota + " (" + quotaInfo.planType + ", whiteLabel=" + settings.whiteLabelEnabled + ")");
        updateQuotaStatus();
        updateBrandingDisplay();
      }
    } catch (e) {
      console.warn("\u26A0\uFE0F Auth init failed, using session auth:", e.message);
    }
  }
  async function checkHealth() {
    try {
      const res = await fetchWithRetry(HEALTH_ENDPOINT, { method: "GET", mode: "cors" }, 2);
      const data = await res.json();
      return data.ok === true;
    } catch (e) {
      console.warn("Health check failed:", e.message);
      return false;
    }
  }
  const HIDDEN_WEEDCOMMERCE_HANDLES = [
    "untitled-nov29_19-11",
    "bailey-s-hip-joint-cbd-soft-chews",
    "calming-cbd-yummies",
    "cbd-paw-nose-balm-baileys-cbd-1"
  ];
  const HIDDEN_WEEDCOMMERCE_IDS = ["9574464094438", "9586869862630", "9574417957094", "9659424375014"];
  function isVisibleStoreProduct(p) {
    if (!IS_WEEDCOMMERCE_DOMAIN) return true;
    const url = p.url || p.productUrl || "";
    const handle = p.handle || (url.match(/\/products\/([^?/#]+)/) || [])[1] || "";
    return HIDDEN_WEEDCOMMERCE_HANDLES.indexOf(handle) === -1 && HIDDEN_WEEDCOMMERCE_IDS.indexOf(String(p.id || "")) === -1 && !/\bbailey['’]?s?\b/i.test(p.title || p.name || "") && !/\b(cbd|cannabidiol|hemp extract)\b/i.test(p.type || p.productType || "");
  }
  async function fetchStoreProducts() {
    try {
      const cached = localStorage.getItem(PRODUCTS_CACHE_KEY);
      if (cached) {
        const { products, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < 15 * 60 * 1e3) {
          console.log("\u2705 Using cached product catalog (" + products.length + " products)");
          storeProducts = products.filter(isVisibleStoreProduct);
          return storeProducts;
        }
      }
    } catch (e) {
      console.warn("Cache read failed:", e);
    }
    try {
      console.log("\u{1F4E6} Fetching store product catalog...");
      let rawProducts = [];
      for (let page = 1; page <= 4; page++) {
        const response = await fetch("/products.json?limit=250&page=" + page, {
          method: "GET",
          headers: { "Accept": "application/json" }
        });
        if (!response.ok) {
          if (page === 1) {
            console.warn("\u26A0\uFE0F Could not fetch products.json");
            return [];
          }
          break;
        }
        const data = await response.json();
        const batch = data.products || [];
        rawProducts = rawProducts.concat(batch);
        if (batch.length < 250) break;
      }
      const products = rawProducts.map((p) => {
        var _a, _b, _c, _d2, _e, _f, _g;
        return {
          title: p.title,
          type: p.product_type || "",
          vendor: p.vendor || "",
          handle: p.handle,
          tags: p.tags || [],
          price: ((_b = (_a = p.variants) == null ? void 0 : _a[0]) == null ? void 0 : _b.price) || "",
          available: ((_c = p.variants) == null ? void 0 : _c.some((v) => v.available)) || false,
          image: ((_e = (_d2 = p.images) == null ? void 0 : _d2[0]) == null ? void 0 : _e.src) || "",
          variantId: ((_g = (_f = p.variants) == null ? void 0 : _f[0]) == null ? void 0 : _g.id) || ""
        };
      }).filter((p) => p.available && isVisibleStoreProduct(p));
      localStorage.setItem(PRODUCTS_CACHE_KEY, JSON.stringify({
        products,
        timestamp: Date.now()
      }));
      storeProducts = products;
      console.log("\u2705 Loaded " + products.length + " products from store");
      return products;
    } catch (e) {
      console.warn("\u26A0\uFE0F Failed to fetch products:", e.message);
      return [];
    }
  }
  function _selectRelevantProducts(question, products, limit) {
    var words = (question || "").toLowerCase().split(/[^a-z0-9]+/).filter(function(w) {
      return w.length > 2;
    });
    if (words.length === 0) return products.slice(0, limit);
    var scored = products.map(function(p) {
      var hay = ((p.title || "") + " " + (p.type || "") + " " + (p.vendor || "") + " " + (Array.isArray(p.tags) ? p.tags.join(" ") : "")).toLowerCase();
      var score = 0;
      for (var i = 0; i < words.length; i++) {
        if (hay.indexOf(words[i]) !== -1) score++;
      }
      return { p, s: score };
    });
    scored.sort(function(a, b) {
      return b.s - a.s;
    });
    var relevant = scored.filter(function(x) {
      return x.s > 0;
    }).map(function(x) {
      return x.p;
    });
    if (relevant.length >= limit) return relevant.slice(0, limit);
    var chosen = relevant.slice();
    for (var j = 0; j < products.length && chosen.length < limit; j++) {
      if (chosen.indexOf(products[j]) === -1) chosen.push(products[j]);
    }
    return chosen;
  }
  async function _buildQueryRequest(question) {
    storeProducts = storeProducts.filter(isVisibleStoreProduct);
    if (storeProducts.length === 0 && isShopifyStore() && !config.apiKey) {
      await fetchStoreProducts();
    }
    const contextualQuery = productInfo.title ? 'Customer viewing "' + productInfo.title + '". Question: ' + question : question;
    const productCatalog = config.apiKey ? null : settings.productCatalog ? settings.productCatalog : storeProducts.length > 0 ? _selectRelevantProducts(question, storeProducts, 50).map(function(p) {
      var info = p.title;
      if (p.type) info += " (" + p.type + ")";
      if (p.vendor && p.vendor.toLowerCase() !== shopDomain.split(".")[0].toLowerCase()) {
        info += " [" + p.vendor + "]";
      }
      if (p.tags && Array.isArray(p.tags) && p.tags.length > 0) {
        info += " {" + p.tags.slice(0, 3).join(", ") + "}";
      }
      return info;
    }).join("\n") : null;
    const effectiveInventoryOnly = settings.inventoryOnly || !config.apiKey && storeProducts.length > 0;
    const bodyObj = {
      query: contextualQuery,
      sessionId,
      shopDomain,
      isShopifyWidget: true,
      inventoryOnly: effectiveInventoryOnly,
      shopName: settings.shopName || shopDomain.replace(".myshopify.com", ""),
      currentProduct: productInfo.title ? {
        title: productInfo.title,
        type: productInfo.type,
        vendor: productInfo.vendor,
        handle: productInfo.handle
      } : null,
      productCatalog
    };
    const bodyStr = JSON.stringify(bodyObj);
    const timestamp = Date.now().toString();
    const signature = await generateSignature(bodyStr, timestamp);
    const headers = { "Content-Type": "application/json" };
    const widgetApiKey = config.apiKey || settings.apiKey || "";
    if (widgetApiKey) headers["x-api-key"] = widgetApiKey;
    if (signature) {
      headers["X-Widget-Signature"] = signature;
      headers["X-Widget-Timestamp"] = timestamp;
      headers["X-Shopify-Shop-Domain"] = shopDomain;
    }
    return { bodyStr, headers };
  }
  async function _prepareQuestionRequest(question) {
    var timeout;
    try {
      return await Promise.race([
        _buildQueryRequest(question),
        new Promise(function(_, reject) {
          timeout = setTimeout(function() {
            var error = new Error("Could not load the store context. Please try again.");
            error.noAutomaticRetry = true;
            reject(error);
          }, 12e3);
        })
      ]);
    } finally {
      clearTimeout(timeout);
    }
  }
  async function askAI(question) {
    var req = await _prepareQuestionRequest(question);
    var controller = new AbortController();
    var timeout = setTimeout(function() {
      controller.abort();
    }, 35e3);
    try {
      var response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: req.headers,
        body: req.bodyStr,
        signal: controller.signal
      });
      var result = await response.json();
      if (!response.ok || !result.response || !result.response.trim()) {
        throw new Error(result.error || "Smoke AI could not complete the answer.");
      }
      return result;
    } catch (error) {
      if (error.name === "AbortError") throw new Error("Smoke AI took too long to respond. Please try again.");
      throw error;
    } finally {
      clearTimeout(timeout);
    }
  }
  const STREAM_ENDPOINT = API_BASE + "/api/cannabis-ai/query-stream";
  var _activeStreamBubble = null;
  var _streamRenderScheduled = false;
  function _createStreamBubble() {
    removeLoading();
    var container = document.getElementById("smoke-ai-messages");
    if (!container) return null;
    var msg = document.createElement("div");
    msg.className = "smoke-ai-message bot";
    msg.id = "smoke-ai-streaming-msg";
    var avatar = document.createElement("img");
    avatar.src = getAvatarImage();
    avatar.alt = "AI";
    avatar.className = "smoke-ai-bot-avatar";
    avatar.onerror = function() {
      this.src = AVATAR_FALLBACK;
    };
    msg.appendChild(avatar);
    var bubble = document.createElement("div");
    bubble.className = "smoke-ai-bubble";
    msg.appendChild(bubble);
    container.appendChild(msg);
    container.scrollTop = container.scrollHeight;
    _activeStreamBubble = bubble;
    return bubble;
  }
  async function askAIStream(question) {
    var req = await _prepareQuestionRequest(question);
    var controller = new AbortController();
    var deadline = setTimeout(function() {
      controller.abort();
    }, 45e3);
    var idleTimer = setTimeout(function() {
      controller.abort();
    }, 25e3);
    var reader;
    try {
      var response = await fetch(STREAM_ENDPOINT, {
        method: "POST",
        headers: req.headers,
        body: req.bodyStr,
        signal: controller.signal
      });
      if (!response.ok) {
        var errData = await response.json().catch(function() {
          return {};
        });
        var e = new Error(errData.error || "Stream failed");
        e.isDemoLimit = errData.isDemoLimit;
        e.requiresCredits = errData.requiresCredits;
        e.canAskFree = errData.canAskFree;
        e.noAutomaticRetry = response.status !== 404 && response.status !== 405;
        throw e;
      }
      if (!response.body || !/text\/event-stream/i.test(response.headers.get("content-type") || "")) {
        throw new Error("Streaming is not available.");
      }
      reader = response.body.getReader();
      var decoder = new TextDecoder();
      var buffer = "";
      var accumulated = "";
      var bubbleCreated = false;
      var completed = false;
      while (!completed) {
        var chunk = await reader.read();
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function() {
          controller.abort();
        }, 2e4);
        buffer += decoder.decode(chunk.value, { stream: true });
        if (chunk.done) buffer += "\n";
        var lines = buffer.split("\n");
        buffer = lines.pop();
        for (var i = 0; i < lines.length; i++) {
          var line = lines[i];
          if (!line.startsWith("data:")) continue;
          var data;
          try {
            data = JSON.parse(line.slice(5).trim());
          } catch (_) {
            continue;
          }
          if (data.t === "chunk") {
            accumulated += data.text;
            if (!bubbleCreated) {
              _createStreamBubble();
              if (_activeStreamBubble) _activeStreamBubble.classList.add("smoke-ai-streaming");
              bubbleCreated = true;
            }
            if (_activeStreamBubble && !_streamRenderScheduled) {
              _streamRenderScheduled = true;
              setTimeout(function() {
                _streamRenderScheduled = false;
                if (_activeStreamBubble) {
                  _activeStreamBubble.innerHTML = formatResponse(accumulated);
                  var c = document.getElementById("smoke-ai-messages");
                  if (c) c.scrollTop = c.scrollHeight;
                }
              }, 30);
            }
          } else if (data.t === "error") {
            var streamError = new Error(data.message || "Smoke AI could not complete the answer.");
            streamError.noAutomaticRetry = true;
            throw streamError;
          } else if (data.t === "done") {
            completed = true;
            break;
          }
        }
        if (chunk.done) break;
      }
      if (!completed || !accumulated.trim()) {
        var incomplete = new Error("The connection ended before Smoke AI completed an answer. Please try again.");
        incomplete.noAutomaticRetry = !!accumulated.trim();
        throw incomplete;
      }
      if (_activeStreamBubble) {
        _activeStreamBubble.classList.remove("smoke-ai-streaming");
        _activeStreamBubble.innerHTML = formatResponse(accumulated);
      }
      _streamRenderScheduled = false;
      return accumulated;
    } catch (error) {
      if (error.name === "AbortError" || error instanceof TypeError) {
        var connectionError = new Error(error.name === "AbortError" ? "Smoke AI took too long to respond. Please try again." : "Could not connect to Smoke AI. Please try again.");
        connectionError.noAutomaticRetry = true;
        throw connectionError;
      }
      throw error;
    } finally {
      clearTimeout(deadline);
      clearTimeout(idleTimer);
      if (reader) reader.cancel().catch(function() {
      });
      _streamRenderScheduled = false;
    }
  }
  function escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }
  function cleanResponseText(text) {
    if (!text) return text;
    var trimmed = text.trim();
    if (trimmed.startsWith("`")) {
      var stripped = trimmed.replace(/^```(?:json|javascript|text)?\s*\n?/i, "").replace(/\n?```\s*$/i, "").trim();
      try {
        var parsed = JSON.parse(stripped);
        if (parsed && typeof parsed.response === "string" && parsed.response.length > 10) {
          return parsed.response;
        }
      } catch (_) {
        var m = stripped.match(/"response"\s*:\s*"((?:[^"\\]|\\[\s\S])*)"/);
        if (m) {
          return m[1].replace(/\\n/g, "\n").replace(/\\"/g, '"').replace(/\\\\/g, "\\");
        }
        if (!stripped.includes('"response"') && stripped.length > 20) {
          return stripped;
        }
      }
    }
    if (trimmed.startsWith("{") && trimmed.endsWith("}")) {
      try {
        var parsed2 = JSON.parse(trimmed);
        if (parsed2 && typeof parsed2.response === "string" && parsed2.response.length > 10) {
          return parsed2.response;
        }
      } catch (_) {
      }
    }
    return text;
  }
  function formatResponse(text) {
    if (!text) return "";
    return text.replace(/\*\*(.+?)\*\*/gs, "<strong>$1</strong>").replace(/__(.+?)__/gs, "<strong>$1</strong>").replace(/\*([^*]+)\*/g, "<em>$1</em>").replace(/\n/g, "<br>");
  }
  function createStyles() {
    const css = `
      .smoke-ai-widget {
        position: fixed;
        z-index: 2147483640;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      }
      body.hide-smoke-ai-widget .smoke-ai-widget,
      body.hide-smoke-ai-widget #smoke-ai-widget,
      body.hide-smoke-ai-widget #smoke-ai-modal { display: none !important; }
      .smoke-ai-widget.position-bottom-right { bottom: 20px; right: 20px; }
      .smoke-ai-widget.position-bottom-left { bottom: 20px; left: 20px; }
      .smoke-ai-widget.position-top-right { top: 20px; right: 20px; }
      .smoke-ai-widget.position-top-left { top: 20px; left: 20px; }
      
      .smoke-ai-button {
        ${settings.logoUrl ? `
          width: 80px; height: 80px; padding: 0; border-radius: 50%; overflow: hidden;
        ` : `
          padding: 18px 32px; border-radius: 50px; min-width: 180px; min-height: 50px;
        `}
        background: linear-gradient(135deg, #059669 0%, #047857 100%);
        color: white;
        border: 2px solid rgba(16, 185, 129, 0.5);
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 4px 16px rgba(5, 150, 105, 0.2);
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }
      .smoke-ai-button:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(5, 150, 105, 0.28);
      }
      .smoke-ai-button img { width: 100%; height: 100%; object-fit: cover; }

      .smoke-ai-launcher {
        position: relative;
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .smoke-ai-ring {
        position: absolute;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 2px solid rgba(16, 185, 129, 0.65);
        animation: smokeAiSonar 2.6s ease-out infinite;
        pointer-events: none;
        top: 0; left: 0;
      }
      .smoke-ai-ring-2 { animation-delay: 0.85s; }
      .smoke-ai-ring-3 { animation-delay: 1.7s; }
      @keyframes smokeAiSonar {
        0%   { transform: scale(1);   opacity: 0.75; }
        100% { transform: scale(2.3); opacity: 0;    }
      }

      /* \u2500\u2500 Teaser popup card \u2500\u2500 */
      .smoke-ai-teaser {
        position: fixed;
        bottom: 116px;
        right: 12px;
        width: 300px;
        background: linear-gradient(160deg, #0d1f14 0%, #0a1a0e 100%);
        border: 1.5px solid rgba(74, 222, 128, 0.55);
        border-radius: 20px;
        padding: 20px 18px 16px;
        box-shadow: 0 0 32px rgba(74, 222, 128, 0.18), 0 8px 40px rgba(0,0,0,0.55);
        z-index: 2147483645;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        color: #fff;
        opacity: 0;
        transform: translateY(12px);
        transition: opacity 0.35s ease, transform 0.35s ease;
        pointer-events: none;
      }
      .smoke-ai-teaser.smoke-ai-teaser-visible {
        opacity: 1;
        transform: translateY(0);
        pointer-events: auto;
      }
      .smoke-ai-teaser-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
      }
      .smoke-ai-teaser-avatar {
        width: 58px;
        height: 58px;
        border-radius: 50%;
        object-fit: cover;
        border: 2.5px solid rgba(74, 222, 128, 0.7);
        box-shadow: 0 0 14px rgba(74, 222, 128, 0.45);
        flex-shrink: 0;
      }
      .smoke-ai-teaser-title {
        font-size: 18px;
        font-weight: 800;
        line-height: 1.2;
        margin: 0 0 2px;
      }
      .smoke-ai-teaser-title span { color: #4ade80; }
      .smoke-ai-teaser-sub {
        font-size: 13px;
        color: #9ca3af;
        margin: 0;
      }
      .smoke-ai-teaser-close {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: rgba(255,255,255,0.08);
        border: none;
        color: #9ca3af;
        font-size: 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        transition: background 0.2s;
      }
      .smoke-ai-teaser-close:hover { background: rgba(255,255,255,0.15); }
      .smoke-ai-teaser-divider {
        height: 1px;
        background: rgba(74, 222, 128, 0.15);
        margin: 0 0 12px;
      }
      .smoke-ai-teaser-body {
        font-size: 15px;
        line-height: 1.55;
        color: #e5e7eb;
        margin: 0 0 16px;
      }
      .smoke-ai-teaser-cta {
        display: block;
        width: 100%;
        padding: 14px;
        background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
        color: #000;
        font-size: 16px;
        font-weight: 800;
        border: none;
        border-radius: 50px;
        cursor: pointer;
        text-align: center;
        letter-spacing: 0.01em;
        box-shadow: 0 4px 18px rgba(34, 197, 94, 0.35);
        transition: filter 0.2s, transform 0.15s;
      }
      .smoke-ai-teaser-cta:hover { filter: brightness(1.08); transform: translateY(-1px); }
      .smoke-ai-teaser-footer {
        text-align: center;
        font-size: 11px;
        color: #6b7280;
        margin-top: 10px;
      }

      .smoke-ai-modal {
        position: fixed;
        top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2147483641;
        backdrop-filter: blur(4px);
      }
      
      .smoke-ai-modal.bubble-mode {
        background: none;
        backdrop-filter: none;
        pointer-events: none;
        top: auto; left: auto;
        right: 0; bottom: 0;
        width: auto; height: auto;
        align-items: flex-end;
        justify-content: flex-end;
      }
      .smoke-ai-modal.bubble-mode .smoke-ai-modal-content {
        pointer-events: auto;
        position: fixed;
        bottom: 90px;
        right: 20px;
        width: 380px;
        max-width: calc(100vw - 32px);
        height: auto;
        min-height: 180px;
        max-height: calc(100vh - 120px);
        border-radius: 16px;
        box-shadow: 0 12px 40px rgba(0,0,0,0.5), 0 0 10px rgba(16,185,129,0.04);
        animation: smoke-ai-slide-up 0.25s ease-out;
      }
      @keyframes smoke-ai-slide-up {
        from { opacity: 0; transform: translateY(20px) scale(0.95); }
        to { opacity: 1; transform: translateY(0) scale(1); }
      }
      /* \u2500\u2500 Desktop: bubble opens as centered modal (same as weedcommerce.co) \u2500\u2500 */
      @media (min-width: 481px) {
        /* Wrapper becomes full-screen centering container */
        .smoke-ai-modal.bubble-mode {
          pointer-events: auto !important;
          top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important;
          width: 100% !important; height: 100% !important;
          align-items: center !important;
          justify-content: center !important;
        }
        /* Card: centered, not fixed to bottom-right */
        .smoke-ai-modal.bubble-mode .smoke-ai-modal-content {
          position: relative !important;
          top: auto !important; left: auto !important;
          right: auto !important; bottom: auto !important;
          width: 460px !important;
          max-width: calc(100vw - 48px) !important;
          height: auto !important;
          min-height: 180px !important;
          max-height: 80vh !important;
          pointer-events: auto !important;
        }
        /* Body: scrollable up to a comfortable height */
        .smoke-ai-modal.bubble-mode .smoke-ai-body {
          flex: none !important;
          max-height: 420px !important;
          overflow-y: auto !important;
        }
      }
      /* \u2500\u2500 Mobile: full-screen centering container \u2500\u2500 */
      @media (max-width: 480px) {
        /* Wrapper becomes a full-screen centering container (like standard modal) */
        .smoke-ai-modal.bubble-mode {
          position: fixed !important;
          top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important;
          width: 100% !important; height: 100% !important;
          pointer-events: none !important;
          align-items: center !important;
          justify-content: center !important;
          background: none !important;
        }
        /* Card: flows into flex center, not fixed to bottom-right */
        .smoke-ai-modal.bubble-mode .smoke-ai-modal-content {
          position: relative !important;
          top: auto !important; left: auto !important;
          right: auto !important; bottom: auto !important;
          width: calc(100% - 24px) !important;
          max-width: calc(100% - 24px) !important;
          height: auto !important;
          max-height: 85vh !important;
          pointer-events: auto !important;
        }
        /* Body sizes to content, not stretchy */
        .smoke-ai-modal.bubble-mode .smoke-ai-body {
          flex: none !important;
        }
      }
      
      .smoke-ai-modal-content {
        background: linear-gradient(135deg, #0f1419 0%, #1a2332 50%, #0d1117 100%);
        border: 2px solid rgba(16, 185, 129, 0.4);
        border-radius: 24px;
        max-width: 700px;
        width: 95%;
        max-height: 90%;
        display: flex;
        flex-direction: column;
        box-shadow: 0 25px 60px rgba(0, 0, 0, 0.55), 0 0 20px rgba(16, 185, 129, 0.06);
        overflow: hidden;
      }
      
      .smoke-ai-header {
        padding: 16px 20px;
        border-bottom: 1px solid rgba(16, 185, 129, 0.3);
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(135deg, rgba(5, 150, 105, 0.25) 0%, rgba(6, 182, 212, 0.15) 50%, rgba(16, 185, 129, 0.2) 100%);
        flex-shrink: 0;
        position: relative;
        overflow: hidden;
      }
      
      .smoke-ai-header::before {
        content: '';
        position: absolute;
        inset: 0;
        background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMiIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjA1KSIvPjwvc3ZnPg==');
        opacity: 0.4;
      }
      
      .smoke-ai-header-title {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      
      .smoke-ai-header-icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        border: 2px solid rgba(16, 185, 129, 0.6);
        object-fit: cover;
        background: rgba(255,255,255,0.1);
        backdrop-filter: blur(4px);
        box-shadow: 0 4px 10px rgba(16, 185, 129, 0.1);
      }
      
      .smoke-ai-header-text h3 {
        margin: 0;
        color: #ffffff;
        font-size: 14px;
        font-weight: 600;
      }
      
      .smoke-ai-header-status {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #10b981;
        font-size: 11px;
        margin-top: 2px;
      }
      
      .smoke-ai-online-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #10b981;
        animation: smokePulse 2s infinite;
      }
      
      @keyframes smokePulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
      
      .smoke-ai-header-text p {
        margin: 2px 0 0 0;
        color: #94a3b8;
        font-size: 11px;
      }
      
      .smoke-ai-close {
        background: transparent;
        border: none;
        font-size: 28px;
        cursor: pointer;
        color: #94a3b8;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 2147483641;
        transition: color 0.2s;
        line-height: 1;
      }
      .smoke-ai-close:hover { color: #e2e8f0; }
      
      .smoke-ai-body {
        padding: 16px;
        background: linear-gradient(180deg, rgba(15, 20, 25, 0.95) 0%, rgba(16, 185, 129, 0.03) 100%);
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;
        box-sizing: border-box;
      }
      
      .smoke-ai-status-bar {
        background: #334155;
        border: 1px solid #475569;
        border-radius: 8px;
        padding: 8px 12px;
        margin-bottom: 12px;
        text-align: left;
        color: #d1d5db;
        font-size: 12px;
        font-weight: 500;
      }
      
      .smoke-ai-product-context {
        background: #1f2937;
        border: 1px solid #374151;
        border-radius: 8px;
        padding: 10px 14px;
        margin-bottom: 12px;
        font-size: 13px;
        color: #9ca3af;
        display: flex;
        align-items: center;
        gap: 6px;
      }
      .smoke-ai-product-context strong { color: #d1d5db; }
      
      .smoke-ai-messages {
        min-height: 80px;
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
        margin-bottom: 12px;
        direction: rtl;
        width: 100%;
        box-sizing: border-box;
      }
      
      .smoke-ai-messages > * {
        direction: ltr;
        max-width: 100%;
        box-sizing: border-box;
      }
      
      .smoke-ai-message {
        margin-bottom: 16px;
        animation: smokeSlideIn 0.3s ease;
      }
      
      @keyframes smokeSlideIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      
      .smoke-ai-message.user {
        display: flex;
        justify-content: flex-end;
      }
      
      .smoke-ai-message.user .smoke-ai-bubble {
        background: linear-gradient(135deg, #10b981, #059669);
        color: #ffffff;
        border: none;
        max-width: 80%;
        border-radius: 16px;
        border-bottom-right-radius: 4px;
      }
      
      .smoke-ai-message.bot {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        max-width: 100%;
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
      }
      
      .smoke-ai-message.bot .smoke-ai-bubble {
        flex: 1;
        min-width: 0;
      }
      
      .smoke-ai-bot-avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 2px solid #34d399;
        object-fit: cover;
        flex-shrink: 0;
        margin-top: 2px;
      }
      
      .smoke-ai-bubble {
        background: rgba(255, 255, 255, 0.1);
        border: none;
        border-radius: 16px;
        border-bottom-left-radius: 4px;
        padding: 10px 14px;
        line-height: 1.5;
        color: #ffffff;
        font-size: 13px;
        max-width: 100%;
        box-sizing: border-box;
        overflow: hidden;
      }
      /* Blinking cursor while AI is streaming a response */
      .smoke-ai-bubble.smoke-ai-streaming::after {
        content: '\u258B';
        display: inline-block;
        color: #10b981;
        font-size: 0.85em;
        margin-left: 1px;
        vertical-align: baseline;
        animation: smoke-ai-cursor-blink 0.65s step-end infinite;
      }
      @keyframes smoke-ai-cursor-blink {
        0%, 100% { opacity: 1; }
        50% { opacity: 0; }
      }
      .smoke-ai-product-card {
        word-break: normal !important;
        overflow-wrap: normal !important;
        white-space: normal !important;
      }
      .smoke-ai-product-card * {
        word-break: normal !important;
        overflow-wrap: normal !important;
      }
      .smoke-ai-bubble strong { color: #ffffff; font-weight: 600; }
      .smoke-ai-bubble ul { margin: 8px 0; padding-left: 18px; }
      .smoke-ai-bubble li { margin: 4px 0; color: #d1d5db; }
      
      .smoke-ai-input-group {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
      }
      
      .smoke-ai-input {
        flex: 1;
        min-width: 0;
        padding: 10px 16px;
        border: 1px solid rgba(71, 85, 105, 0.5);
        border-radius: 12px;
        font-size: 16px !important;
        line-height: 1.4;
        background: rgba(51, 65, 85, 0.5);
        color: #ffffff;
        transition: border-color 0.2s;
        box-sizing: border-box;
        touch-action: manipulation;
        -webkit-text-size-adjust: 100%;
      }
      .smoke-ai-input:focus {
        outline: none;
        border-color: rgba(52, 211, 153, 0.5);
      }
      .smoke-ai-input::placeholder { color: #94a3b8; }
      
      .smoke-ai-send-btn {
        background: #059669;
        color: white;
        border: none;
        border-radius: 12px;
        padding: 10px 16px;
        cursor: pointer;
        transition: background 0.2s;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .smoke-ai-send-btn:hover:not(:disabled) { background: #047857; }
      .smoke-ai-send-btn:disabled { opacity: 0.5; cursor: not-allowed; }
      
      .smoke-ai-loading {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;
        color: #9ca3af;
        font-size: 13px;
      }
      
      .smoke-ai-spinner {
        width: 14px;
        height: 14px;
        border: 2px solid #475569;
        border-top-color: #34d399;
        border-radius: 50%;
        animation: smokeSpin 0.7s linear infinite;
      }
      
      @keyframes smokeSpin {
        to { transform: rotate(360deg); }
      }
      
      .smoke-ai-disclaimer {
        border-top: 1px solid #374151;
        padding: 6px 0 4px 0;
        margin-top: 4px;
        font-size: 10px;
        color: #6b7280;
        text-align: center;
        line-height: 1.3;
      }
      .smoke-ai-disclaimer a {
        color: #34d399;
        text-decoration: none;
      }
      .smoke-ai-disclaimer a:hover { text-decoration: underline; }
      
      .smoke-ai-error {
        background: #7f1d1d;
        border: 1px solid #991b1b;
        border-radius: 8px;
        padding: 12px;
        color: #fecaca;
        font-size: 13px;
        margin-bottom: 12px;
      }
      .smoke-ai-error button {
        background: #dc2626;
        color: white;
        border: none;
        padding: 6px 12px;
        border-radius: 6px;
        cursor: pointer;
        margin-top: 8px;
        font-size: 12px;
      }
      .smoke-ai-error button:hover { background: #b91c1c; }
      
      /* Terms Popup Styles - Neon Botanical - Compact */
      .smoke-ai-terms-overlay {
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2147483642;
        border-radius: 16px;
        padding: 12px;
      }
      
      .smoke-ai-terms-popup {
        background: linear-gradient(145deg, rgba(30, 41, 59, 0.98), rgba(15, 23, 42, 0.99));
        border: 2px solid rgba(16, 185, 129, 0.5);
        border-radius: 12px;
        padding: 10px;
        max-width: 95%;
        width: 300px;
        box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.55), 0 0 16px rgba(16, 185, 129, 0.07);
      }
      
      .smoke-ai-terms-logo {
        display: flex;
        justify-content: center;
        margin-bottom: 4px;
      }
      
      .smoke-ai-terms-logo-inner {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 2px solid rgba(16, 185, 129, 0.6);
        box-shadow: 0 4px 10px rgba(16, 185, 129, 0.12);
        overflow: hidden;
        background: #1e293b;
      }
      
      .smoke-ai-terms-logo img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
      }
      
      .smoke-ai-terms-title {
        color: white;
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 0;
        text-align: center;
      }
      
      .smoke-ai-terms-subtitle {
        color: #9ca3af;
        font-size: 10px;
        text-align: center;
        margin-bottom: 6px;
      }
      
      .smoke-ai-terms-item {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 3px;
        color: #ffffff;
        font-size: 11px;
        font-weight: 500;
        line-height: 1.2;
        padding: 6px 8px;
        background: rgba(30, 41, 59, 0.6);
        border: 1px solid rgba(71, 85, 105, 0.4);
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.25s ease;
      }
      
      .smoke-ai-terms-item:hover {
        background: rgba(16, 185, 129, 0.12);
        border-color: rgba(16, 185, 129, 0.4);
      }
      
      .smoke-ai-terms-item.checked {
        background: rgba(16, 185, 129, 0.15);
        border-color: rgba(16, 185, 129, 0.5);
      }
      
      .smoke-ai-terms-item label {
        cursor: pointer;
        flex: 1;
        font-weight: 500;
      }
      
      .smoke-ai-terms-checkbox {
        display: none;
      }
      
      .smoke-ai-custom-checkbox {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        border: none;
        background: rgba(71, 85, 105, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: all 0.25s ease;
      }
      
      .smoke-ai-custom-checkbox.checked {
        background: linear-gradient(135deg, #10b981, #059669);
        border: none;
        box-shadow: 0 2px 6px rgba(16, 185, 129, 0.18);
      }
      
      .smoke-ai-check-icon {
        width: 16px;
        height: 16px;
        color: white;
        opacity: 0;
        transition: opacity 0.15s ease;
      }
      
      .smoke-ai-custom-checkbox.checked .smoke-ai-check-icon {
        opacity: 1;
      }
      
      .smoke-ai-terms-icon {
        font-size: 14px;
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #10b981;
      }
      
      .smoke-ai-terms-text {
        flex: 1;
        font-size: 12px;
        font-weight: 500;
        color: white;
      }
      
      .smoke-ai-terms-btn {
        width: 100%;
        background: rgba(55, 65, 81, 0.8);
        color: #d1d5db;
        border: none;
        border-radius: 8px;
        padding: 8px;
        font-size: 12px;
        font-weight: 700;
        cursor: not-allowed;
        margin-top: 6px;
        transition: all 0.3s ease;
      }
      
      .smoke-ai-terms-btn.enabled {
        background: linear-gradient(135deg, #10b981, #059669);
        color: white;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
        opacity: 1;
      }
      
      .smoke-ai-terms-btn.enabled:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(16, 185, 129, 0.2);
      }
      
      .smoke-ai-terms-footer {
        text-align: center;
        color: #6b7280;
        font-size: 9px;
        margin-top: 4px;
      }
      
      /* Product Card Styles - Swipe Shelf (vertical card) */
      .smoke-ai-product-card {
        flex-shrink: 0;
        width: 152px;
        background: #111c17;
        border: 1px solid rgba(16,185,129,0.28);
        border-radius: 16px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding: 0;
        margin-top: 0;
        box-sizing: border-box;
      }
      /* Image box \u2014 width controlled by class so single-card override works */
      .smoke-ai-card-img-box {
        width: 152px;
        height: 120px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        flex-shrink: 0;
      }
      /* Single-card: stretch to fill the message bubble */
      .smoke-ai-shelf-single {
        overflow-x: hidden !important;
      }
      .smoke-ai-shelf-single .smoke-ai-product-card {
        width: 100% !important;
        flex-shrink: 1;
      }
      .smoke-ai-shelf-single .smoke-ai-card-img-box {
        width: 100% !important;
        height: 150px !important;
      }
      /* View Product link inside card */
      .smoke-ai-view-btn {
        display: block;
        width: 100%;
        margin-top: 8px;
        padding: 6px 0;
        border-radius: 8px;
        background: rgba(16,185,129,0.10);
        border: 1px solid rgba(16,185,129,0.22);
        color: #10b981;
        font-size: 11px;
        font-weight: 600;
        text-align: center;
        text-decoration: none;
        box-sizing: border-box;
        letter-spacing: 0.01em;
      }
      .smoke-ai-view-btn:hover {
        background: rgba(16,185,129,0.18);
        color: #34d399;
      }
      /* Hide scrollbar on the horizontal shelf */
      .smoke-ai-cards-scroll::-webkit-scrollbar { display: none; }
      .smoke-ai-cards-scroll { -ms-overflow-style: none; scrollbar-width: none; }
      
      .smoke-ai-product-image {
        width: 100px;
        height: 100px;
        min-width: 100px;
        border-radius: 12px;
        object-fit: cover;
        background: #ffffff;
        border: 1px solid rgba(16, 185, 129, 0.3);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
      }
      
      .smoke-ai-product-info {
        display: flex;
        flex-direction: column;
        gap: 6px;
        flex: 1;
        min-width: 0;
      }
      
      .smoke-ai-product-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 8px;
      }
      
      .smoke-ai-product-name {
        color: #ffffff;
        font-weight: 700;
        font-size: 15px;
        line-height: 1.25;
      }
      
      .smoke-ai-star-badge {
        display: inline-flex;
        align-items: center;
        gap: 3px;
        background: rgba(52, 83, 67, 0.95);
        padding: 4px 8px;
        border-radius: 8px;
        flex-shrink: 0;
      }
      
      .smoke-ai-star-badge span {
        color: #facc15;
        font-size: 12px;
        font-weight: 700;
      }
      
      .smoke-ai-product-type {
        display: inline-block;
        background: rgba(16, 185, 129, 0.3);
        color: #6ee7b7;
        font-size: 11px;
        font-weight: 600;
        padding: 4px 10px;
        border-radius: 20px;
        border: 1px solid rgba(16, 185, 129, 0.5);
      }
      
      .smoke-ai-badges-row {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
      }
      
      .smoke-ai-thc-badge {
        color: #22d3ee;
        font-size: 12px;
        font-weight: 700;
      }
      
      .smoke-ai-effects-text {
        color: #9ca3af;
        font-size: 12px;
      }
      
      .smoke-ai-product-footer {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 4px;
      }
      
      .smoke-ai-product-price {
        color: #10b981;
        font-weight: 800;
        font-size: 20px;
      }
      
      .smoke-ai-product-actions {
        display: flex;
        gap: 8px;
        margin-left: auto;
      }
      
      .smoke-ai-product-btn {
        background: rgba(255, 255, 255, 0.06);
        color: #9ca3af;
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 8px;
        padding: 7px 14px;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
        text-align: center;
        text-decoration: none;
        transition: background 0.15s, color 0.15s;
      }
      .smoke-ai-product-btn:hover {
        background: rgba(255, 255, 255, 0.1);
        color: #ffffff;
      }
      
      .smoke-ai-add-cart-btn {
        background: #059669;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 7px 14px;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        text-align: center;
        transition: background 0.15s;
      }
      .smoke-ai-add-cart-btn:hover:not(:disabled) {
        background: #10b981;
      }
      
      .smoke-ai-add-cart-btn:disabled {
        background: #374151;
        cursor: not-allowed;
        color: #6b7280;
      }
      
      .smoke-ai-add-cart-btn.success {
        background: #047857;
      }
      
      /* Mobile Optimization for Product Cards */
      @media (max-width: 380px) {
        .smoke-ai-product-card {
          padding: 12px;
          gap: 10px;
        }
        
        .smoke-ai-product-image {
          width: 80px;
          height: 80px;
          min-width: 80px;
        }
        
        .smoke-ai-product-name {
          font-size: 13px;
        }
        
        .smoke-ai-product-footer {
          flex-wrap: wrap;
          gap: 8px;
        }
        
        .smoke-ai-product-price {
          font-size: 18px;
          width: 100%;
        }
        
        .smoke-ai-product-actions {
          margin-left: 0;
          width: 100%;
          justify-content: flex-start;
        }
        
        .smoke-ai-product-btn,
        .smoke-ai-add-cart-btn {
          padding: 8px 14px;
          font-size: 11px;
        }
      }
      
      `;
    const style = document.createElement("style");
    style.id = "smoke-ai-styles";
    style.textContent = css;
    document.head.appendChild(style);
  }
  function createButton() {
    const widget = document.createElement("div");
    widget.className = "smoke-ai-widget position-" + settings.position;
    widget.id = "smoke-ai-widget";
    const launcher = document.createElement("div");
    launcher.className = "smoke-ai-launcher";
    if (IS_WEEDCOMMERCE_DOMAIN) {
      const ring1 = document.createElement("div");
      ring1.className = "smoke-ai-ring smoke-ai-ring-1";
      const ring2 = document.createElement("div");
      ring2.className = "smoke-ai-ring smoke-ai-ring-2";
      const ring3 = document.createElement("div");
      ring3.className = "smoke-ai-ring smoke-ai-ring-3";
      launcher.appendChild(ring1);
      launcher.appendChild(ring2);
      launcher.appendChild(ring3);
    }
    const btn = document.createElement("button");
    btn.className = "smoke-ai-button";
    btn.onclick = openModal;
    const avatarUrl = getAvatarImage();
    btn.innerHTML = '<img src="' + avatarUrl + '" alt="Smoke AI">';
    btn.style.cssText = "width: 80px; height: 80px; padding: 0; border-radius: 50%; overflow: hidden; min-width: unset; position: relative; z-index: 1;";
    launcher.appendChild(btn);
    widget.appendChild(launcher);
    document.body.appendChild(widget);
  }
  function showTeaserPopup() {
    if (document.getElementById("smoke-ai-teaser")) return;
    var avatarUrl = getAvatarImage();
    var popup = document.createElement("div");
    popup.id = "smoke-ai-teaser";
    popup.className = "smoke-ai-teaser";
    popup.innerHTML = '<button id="smoke-ai-teaser-close" class="smoke-ai-teaser-close" aria-label="Close">\xD7</button><div class="smoke-ai-teaser-header"><img src="' + avatarUrl + `" class="smoke-ai-teaser-avatar" alt="Smoke AI"><div><p class="smoke-ai-teaser-title">Hi, I'm <span>Smoke AI</span></p><p class="smoke-ai-teaser-sub">Your 24/7 Budtender</p></div></div><div class="smoke-ai-teaser-divider"></div><p class="smoke-ai-teaser-body">Get personalized product recommendations, answers, and shopping help in seconds.</p><button id="smoke-ai-teaser-cta" class="smoke-ai-teaser-cta">\u2726 Ask Smoke AI \u2192</button><p class="smoke-ai-teaser-footer">\u{1F512} Private. Fast. Always here to help.</p>`;
    document.body.appendChild(popup);
    setTimeout(function() {
      popup.classList.add("smoke-ai-teaser-visible");
    }, 40);
    document.getElementById("smoke-ai-teaser-close").onclick = closeTeaserPopup;
    document.getElementById("smoke-ai-teaser-cta").onclick = function() {
      closeTeaserPopup();
      openModal();
    };
  }
  function closeTeaserPopup() {
    var popup = document.getElementById("smoke-ai-teaser");
    if (popup) {
      popup.classList.remove("smoke-ai-teaser-visible");
      setTimeout(function() {
        if (popup.parentNode) popup.parentNode.removeChild(popup);
      }, 350);
    }
    var rings = document.querySelectorAll(".smoke-ai-ring");
    for (var i = 0; i < rings.length; i++) {
      rings[i].style.display = "none";
    }
  }
  function createModal() {
    const productContext = productInfo.title ? '<div class="smoke-ai-product-context"><strong>Viewing:</strong> ' + escapeHtml(productInfo.title) + (productInfo.type ? " (" + escapeHtml(productInfo.type) + ")" : "") + "</div>" : "";
    const modal = document.createElement("div");
    modal.id = "smoke-ai-modal";
    modal.className = "smoke-ai-modal" + (settings.bubbleMode ? " bubble-mode" : "");
    modal.style.display = "none";
    const avatarUrl = getAvatarImage();
    modal.innerHTML = `
      <div class="smoke-ai-modal-content">
        <div class="smoke-ai-header">
          <div class="smoke-ai-header-title">
            <img src="${avatarUrl}" onerror="this.src='${AVATAR_FALLBACK}'" alt="Smoke AI" class="smoke-ai-header-icon">
            <div class="smoke-ai-header-text">
              <h3>Smoke AI</h3>
              <div class="smoke-ai-header-status">
                <span class="smoke-ai-online-dot"></span>
                Online
              </div>
            </div>
          </div>
          <button class="smoke-ai-close" id="smoke-ai-close">&times;</button>
        </div>
        <div class="smoke-ai-body">
          <div class="smoke-ai-status-bar" id="smoke-ai-status" style="display:none;"></div>
          ${productContext}
          <div class="smoke-ai-messages" id="smoke-ai-messages">
            <div class="smoke-ai-message bot">
              <img src="${avatarUrl}" onerror="this.src='${AVATAR_FALLBACK}'" alt="AI" class="smoke-ai-bot-avatar">
              <div class="smoke-ai-bubble">
                \u{1F44B} <strong>Hi! I'm Smoke AI.</strong><br><br>
                Ask me about cannabis strains, effects, medical benefits, dosing, or product recommendations!
              </div>
            </div>
          </div>
          <div class="smoke-ai-input-group">
            <input type="text" class="smoke-ai-input" id="smoke-ai-input" 
              placeholder="${productInfo.title ? "Ask about " + escapeHtml(productInfo.title) + "..." : config.searchPlaceholder || settings.searchPlaceholder || "Ask about cannabis strains, effects, benefits..."}">
            <button class="smoke-ai-send-btn" id="smoke-ai-send" aria-label="Send"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button>
          </div>
          <div class="smoke-ai-disclaimer">
            ${settings.hideAgeDisclaimer && settings.whiteLabelEnabled && settings.storeName ? "" : "<strong>21+</strong> \u2022 Educational only \u2022 Not medical advice"}
            ${settings.whiteLabelEnabled && settings.storeName ? "" : '<br><a href="https://smokeai.chat/terms-of-service" target="_blank">View Full Terms</a>'}
            ${settings.whiteLabelEnabled && settings.storeName ? "" : '<div style="margin-top: 2px; font-size: 9px; color: #9ca3af;">Powered by Weedcommerce</div>'}
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    document.getElementById("smoke-ai-close").onclick = closeModal;
    document.getElementById("smoke-ai-send").onclick = handleSend;
    document.getElementById("smoke-ai-input").onkeypress = function(e) {
      if (e.key === "Enter") handleSend();
    };
    modal.onclick = function(e) {
      if (e.target === modal) closeModal();
    };
  }
  let welcomeMessageShown = false;
  function showWelcomeMessage() {
    if (welcomeMessageShown) return;
    welcomeMessageShown = true;
    const defaultMessage = settings.whiteLabelEnabled ? "Hi! I'm here to help you find the perfect products. What are you looking for today?" : "Hi! I'm Smoke AI. Ask me anything about our products and I'll help you find the perfect match for your needs.";
    const welcomeText = settings.welcomeMessage || config.welcomeMessage || defaultMessage;
    addMessage(welcomeText, true, false);
  }
  function openModal() {
    const modal = document.getElementById("smoke-ai-modal");
    if (modal) {
      if (!settings.bubbleMode && !document.getElementById("smoke-ai-backdrop")) {
        const backdrop = document.createElement("div");
        backdrop.id = "smoke-ai-backdrop";
        backdrop.style.cssText = [
          "position:fixed",
          "top:0",
          "left:0",
          "width:100%",
          "height:100%",
          "background:rgba(0,0,0,0.55)",
          "backdrop-filter:blur(6px)",
          "-webkit-backdrop-filter:blur(6px)",
          "z-index:2147483640",
          "transition:opacity 0.2s ease"
        ].join(";");
        backdrop.onclick = closeModal;
        document.body.appendChild(backdrop);
      }
      modal.style.display = "flex";
      updateBrandingDisplay();
      setTimeout(() => {
        const input = document.getElementById("smoke-ai-input");
        if (input) input.focus();
      }, 100);
    }
  }
  function closeModal() {
    const modal = document.getElementById("smoke-ai-modal");
    if (modal) modal.style.display = "none";
    const backdrop = document.getElementById("smoke-ai-backdrop");
    if (backdrop) backdrop.remove();
  }
  function addMessage(content, isBot, isLoading) {
    const container = document.getElementById("smoke-ai-messages");
    if (!container) return;
    const msg = document.createElement("div");
    msg.className = "smoke-ai-message " + (isBot ? "bot" : "user");
    const avatarUrl = getAvatarImage();
    if (isLoading) {
      msg.id = "smoke-ai-loading";
      var loadingAvatar = document.createElement("img");
      loadingAvatar.src = avatarUrl;
      loadingAvatar.alt = "AI";
      loadingAvatar.className = "smoke-ai-bot-avatar";
      loadingAvatar.onerror = function() {
        this.src = AVATAR_FALLBACK;
      };
      msg.appendChild(loadingAvatar);
      var loadingDiv = document.createElement("div");
      loadingDiv.className = "smoke-ai-loading";
      var spinner = document.createElement("div");
      spinner.className = "smoke-ai-spinner";
      loadingDiv.appendChild(spinner);
      var loadingText = document.createElement("span");
      loadingText.className = "smoke-ai-loading-text";
      loadingText.textContent = "Analyzing your question...";
      loadingDiv.appendChild(loadingText);
      msg.appendChild(loadingDiv);
    } else if (isBot) {
      var botAvatar = document.createElement("img");
      botAvatar.src = avatarUrl;
      botAvatar.alt = "AI";
      botAvatar.className = "smoke-ai-bot-avatar";
      botAvatar.onerror = function() {
        this.src = AVATAR_FALLBACK;
      };
      msg.appendChild(botAvatar);
      var bubbleDiv = document.createElement("div");
      bubbleDiv.className = "smoke-ai-bubble";
      bubbleDiv.innerHTML = formatResponse(content);
      msg.appendChild(bubbleDiv);
    } else {
      const bubble = document.createElement("div");
      bubble.className = "smoke-ai-bubble";
      bubble.textContent = content;
      msg.appendChild(bubble);
    }
    container.appendChild(msg);
    if (isBot && !isLoading) {
      setTimeout(function() {
        _initSliderWidths();
        try {
          msg.scrollIntoView({ behavior: "smooth", block: "start" });
        } catch (e) {
          container.scrollTop = msg.offsetTop - 10;
        }
        console.log("\u{1F51D} Smoke AI: Scrolled to top of response");
      }, 100);
    } else {
      container.scrollTop = container.scrollHeight;
    }
  }
  function removeLoading() {
    const loading = document.getElementById("smoke-ai-loading");
    if (loading) loading.remove();
  }
  function showError(message, retryQuestion) {
    const container = document.getElementById("smoke-ai-messages");
    if (!container) return;
    const err = document.createElement("div");
    err.className = "smoke-ai-error";
    err.innerHTML = `
      <strong>\u26A0\uFE0F Connection Error</strong><br>
      ${escapeHtml(message)}<br>
      <button onclick="this.parentElement.remove()">Dismiss</button>
    `;
    container.appendChild(err);
    if (retryQuestion) {
      var retry = document.createElement("button");
      retry.type = "button";
      retry.textContent = "Try again";
      retry.addEventListener("click", function() {
        if (_questionInFlight) return;
        err.remove();
        processQuestion(retryQuestion);
      });
      err.appendChild(retry);
    }
    container.scrollTop = container.scrollHeight;
  }
  function showTermsPopup() {
    const modalContent = document.querySelector(".smoke-ai-modal-content");
    if (!modalContent) return;
    const overlay = document.createElement("div");
    overlay.id = "smoke-ai-terms-overlay";
    overlay.className = "smoke-ai-terms-overlay";
    overlay.innerHTML = `
      <div class="smoke-ai-terms-popup">
        <div class="smoke-ai-terms-logo">
          <div class="smoke-ai-terms-logo-inner">
            <img src="${API_BASE}/smoke-ai-mascot.png" alt="Smoke AI" onerror="this.parentElement.innerHTML='<div style=\\'display:flex;align-items:center;justify-content:center;height:100%;font-size:24px;\\'>\u{1F33F}</div>'">
          </div>
        </div>
        <div class="smoke-ai-terms-title">21+ Verification</div>
        <div class="smoke-ai-terms-subtitle">Please confirm before using Smoke AI</div>
        <div class="smoke-ai-terms-item" data-checkbox="terms-age">
          <div class="smoke-ai-custom-checkbox" id="terms-age-box">
            <svg class="smoke-ai-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
          </div>
          <span class="smoke-ai-terms-icon">\u{1F464}</span>
          <span class="smoke-ai-terms-text">I am 21 years of age or older</span>
          <input type="checkbox" class="smoke-ai-terms-checkbox" id="terms-age">
        </div>
        <div class="smoke-ai-terms-item" data-checkbox="terms-legal">
          <div class="smoke-ai-custom-checkbox" id="terms-legal-box">
            <svg class="smoke-ai-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
          </div>
          <span class="smoke-ai-terms-icon">\u{1F4CD}</span>
          <span class="smoke-ai-terms-text">Cannabis is legal in my area</span>
          <input type="checkbox" class="smoke-ai-terms-checkbox" id="terms-legal">
        </div>
        <div class="smoke-ai-terms-item" data-checkbox="terms-doctor">
          <div class="smoke-ai-custom-checkbox" id="terms-doctor-box">
            <svg class="smoke-ai-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
          </div>
          <span class="smoke-ai-terms-icon">\u{1FA7A}</span>
          <span class="smoke-ai-terms-text">I will consult a doctor for medical advice</span>
          <input type="checkbox" class="smoke-ai-terms-checkbox" id="terms-doctor">
        </div>
        <div class="smoke-ai-terms-item" data-checkbox="terms-advice">
          <div class="smoke-ai-custom-checkbox" id="terms-advice-box">
            <svg class="smoke-ai-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
          </div>
          <span class="smoke-ai-terms-icon">\u{1F4C4}</span>
          <span class="smoke-ai-terms-text">I understand this is not medical advice</span>
          <input type="checkbox" class="smoke-ai-terms-checkbox" id="terms-advice">
        </div>
        <button class="smoke-ai-terms-btn" id="terms-continue">Please confirm all items</button>
        <div class="smoke-ai-terms-footer">By continuing, you agree to our Terms</div>
      </div>
    `;
    modalContent.style.position = "relative";
    modalContent.appendChild(overlay);
    const checkboxes = overlay.querySelectorAll(".smoke-ai-terms-checkbox");
    const items = overlay.querySelectorAll(".smoke-ai-terms-item");
    const continueBtn = document.getElementById("terms-continue");
    function updateButton() {
      const allChecked = Array.from(checkboxes).every((cb) => cb.checked);
      if (allChecked) {
        continueBtn.textContent = "\u2705 Continue to Smoke AI";
        continueBtn.classList.add("enabled");
      } else {
        continueBtn.textContent = "Please confirm all items";
        continueBtn.classList.remove("enabled");
      }
    }
    items.forEach((item) => {
      item.addEventListener("click", function() {
        const checkboxId = this.getAttribute("data-checkbox");
        const checkbox = document.getElementById(checkboxId);
        const customBox = document.getElementById(checkboxId + "-box");
        if (checkbox && customBox) {
          checkbox.checked = !checkbox.checked;
          customBox.classList.toggle("checked", checkbox.checked);
          this.classList.toggle("checked", checkbox.checked);
          updateButton();
        }
      });
    });
    checkboxes.forEach((cb) => cb.addEventListener("change", function() {
      const customBox = document.getElementById(cb.id + "-box");
      const item = document.querySelector('[data-checkbox="' + cb.id + '"]');
      if (customBox) {
        customBox.classList.toggle("checked", cb.checked);
      }
      if (item) {
        item.classList.toggle("checked", cb.checked);
      }
      updateButton();
    }));
    continueBtn.onclick = function() {
      const allChecked = Array.from(checkboxes).every((cb) => cb.checked);
      if (allChecked) {
        termsAccepted = true;
        localStorage.setItem(TERMS_KEY, "true");
        overlay.remove();
        if (pendingQuestion) {
          processQuestion(pendingQuestion);
          pendingQuestion = null;
        }
      }
    };
  }
  function isShopifyStore() {
    if (window.Shopify) return true;
    if (window.location.hostname.endsWith(".myshopify.com")) return true;
    if (document.querySelector('meta[name="shopify-checkout-api-token"]')) return true;
    if (document.querySelector('script[src*="cdn.shopify.com"]')) return true;
    return false;
  }
  async function getVariantIdFromHandle(handle) {
    if (!handle) return null;
    try {
      const response = await fetch("/products/" + handle + ".js");
      if (response.ok) {
        const product = await response.json();
        if (product.variants && product.variants.length > 0) {
          const available = product.variants.find((v) => v.available) || product.variants[0];
          console.log("\u2705 Found variant for", handle, ":", available.id);
          return available.id;
        }
      }
    } catch (err) {
      console.error("Failed to fetch variant for", handle, err);
    }
    return null;
  }
  async function addToShopifyCart(variantId, quantity = 1) {
    console.log("\u{1F6D2} addToShopifyCart called:", { variantId, quantity, isShopify: isShopifyStore(), shopDomain });
    if (isShopifyStore()) {
      try {
        const numericVariantId = parseInt(String(variantId).replace(/\D/g, ""), 10);
        console.log("\u{1F6D2} Calling /cart/add.js with variant:", numericVariantId, "(original:", variantId, ")");
        if (!numericVariantId || isNaN(numericVariantId)) {
          console.error("\u274C Invalid variant ID:", variantId);
          return { success: false, error: "Invalid variant ID" };
        }
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: numericVariantId,
            quantity
          })
        });
        if (response.ok) {
          const data = await response.json();
          console.log("\u2705 Added to cart:", data);
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          window.dispatchEvent(new CustomEvent("cart:refresh"));
          document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
          document.body.dispatchEvent(new CustomEvent("product:added", { bubbles: true }));
          try {
            const cartCountEl = document.querySelector(".cart-count, .cart-item-count, [data-cart-count], .js-cart-count, #cart-icon-bubble span");
            if (cartCountEl) {
              const currentCount = parseInt(cartCountEl.textContent) || 0;
              cartCountEl.textContent = currentCount + quantity;
              console.log("\u2705 Updated cart count badge:", currentCount + quantity);
            }
            const cartResponse = await fetch("/cart.js");
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              console.log("\u{1F4CA} Cart verified, total items:", cart.item_count, "total price:", cart.total_price);
              const countSelectors = [
                ".cart-count",
                ".cart-item-count",
                "[data-cart-count]",
                ".js-cart-count",
                "#cart-icon-bubble span",
                ".cart-count-bubble",
                "[data-cart-item-count]",
                ".site-header__cart-count",
                ".header__cart-count",
                ".cart-link__count"
              ];
              const countEls = document.querySelectorAll(countSelectors.join(","));
              countEls.forEach((el) => {
                el.textContent = cart.item_count;
                el.style.display = cart.item_count > 0 ? "" : "none";
              });
              window.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
              document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
              try {
                const iconBubbleEl = document.getElementById("shopify-section-cart-icon-bubble");
                if (iconBubbleEl) {
                  fetch("/?sections=cart-icon-bubble").then((r) => r.ok ? r.json() : null).then(function(data2) {
                    if (!data2 || !data2["cart-icon-bubble"]) return;
                    const tmp = document.createElement("div");
                    tmp.innerHTML = data2["cart-icon-bubble"];
                    const fresh = tmp.querySelector("#shopify-section-cart-icon-bubble") || tmp.firstElementChild;
                    if (fresh && iconBubbleEl.parentNode) {
                      iconBubbleEl.outerHTML = fresh.outerHTML;
                    }
                  }).catch(function() {
                  });
                }
                const cartDrawerEl = document.querySelector("cart-drawer");
                if (cartDrawerEl && typeof cartDrawerEl.renderContents === "function") {
                  cartDrawerEl.renderContents({ requestType: "add", cart });
                }
                const miniCart = document.getElementById("mini-cart");
                if (miniCart) {
                  const countEl = miniCart.querySelector(".cart-count, .cart-item-count, [data-cart-count], [data-cart-item-count]");
                  if (countEl) countEl.textContent = cart.item_count;
                  miniCart.setAttribute("data-item-count", cart.item_count);
                }
                document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
                window.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
              } catch (e) {
              }
            }
          } catch (e) {
            console.log("Cart badge update attempted:", e);
          }
          return { success: true, data, itemCount: data.quantity };
        } else {
          const errorText = await response.text();
          console.error("\u274C Cart error:", response.status, errorText);
          try {
            const error = JSON.parse(errorText);
            return { success: false, error: error.description || "Failed to add to cart" };
          } catch {
            return { success: false, error: errorText || "Failed to add to cart" };
          }
        }
      } catch (err) {
        console.error("\u274C Cart request failed:", err);
        return { success: false, error: err.message };
      }
    }
    if (shopDomain && variantId) {
      const cartUrl = `https://${shopDomain}/cart/${variantId}:${quantity}`;
      console.log("\u{1F6D2} Redirecting to Shopify cart:", cartUrl);
      window.open(cartUrl, "_blank");
      return { success: true, redirected: true };
    }
    console.log("\u274C Cannot add to cart - missing shop domain or variant ID");
    return { success: false, error: "Cannot add to cart" };
  }
  window.smokeAIAddToCart = async function(variantId, buttonId) {
    console.log("\u{1F6D2} smokeAIAddToCart called:", { variantId, buttonId });
    const btn = document.getElementById(buttonId);
    if (!btn) {
      console.error("\u274C Button not found:", buttonId);
      return;
    }
    btn.disabled = true;
    _setBtnIcon(btn, _spinIcon);
    const result = await addToShopifyCart(variantId);
    console.log("\u{1F6D2} Add to cart result:", result);
    if (result.success) {
      _setBtnIcon(btn, _checkIcon, "#16a34a");
      setTimeout(() => {
        _setBtnIcon(btn, _plusIcon);
        btn.disabled = false;
      }, 2e3);
    } else {
      _setBtnIcon(btn, _xIcon, "#dc2626");
      setTimeout(() => {
        _setBtnIcon(btn, _plusIcon);
        btn.disabled = false;
      }, 2e3);
    }
  };
  window.smokeAIAddToCartByHandle = async function(handle, buttonId) {
    console.log("\u{1F6D2} smokeAIAddToCartByHandle called:", { handle, buttonId });
    const btn = document.getElementById(buttonId);
    if (!btn) {
      console.error("\u274C Button not found:", buttonId);
      return;
    }
    btn.disabled = true;
    _setBtnIcon(btn, _spinIcon);
    console.log("\u{1F50D} Fetching variant for handle:", handle);
    const variantId = await getVariantIdFromHandle(handle);
    console.log("\u{1F50D} Got variantId:", variantId);
    if (!variantId) {
      _setBtnIcon(btn, _xIcon, "#dc2626");
      setTimeout(() => {
        _setBtnIcon(btn, _plusIcon);
        btn.disabled = false;
      }, 2500);
      return;
    }
    const result = await addToShopifyCart(variantId);
    if (result.success) {
      _setBtnIcon(btn, _checkIcon, "#16a34a");
      setTimeout(() => {
        _setBtnIcon(btn, _plusIcon);
        btn.disabled = false;
      }, 2500);
    } else {
      _setBtnIcon(btn, _xIcon, "#dc2626");
      setTimeout(() => {
        _setBtnIcon(btn, _plusIcon);
        btn.disabled = false;
      }, 2500);
    }
  };
  if (!window.smokeAiSliderState) window.smokeAiSliderState = {};
  function _initSliderWidths() {
    var tracks = document.querySelectorAll('[id$="-track"]');
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      var container = track.parentElement;
      if (!container) continue;
      var w = container.offsetWidth;
      if (!w) continue;
      var slides = track.children;
      for (var j = 0; j < slides.length; j++) {
        slides[j].style.width = w + "px";
        slides[j].style.minWidth = w + "px";
        slides[j].style.flexShrink = "0";
      }
    }
  }
  function _smokeAiSlideMove(id) {
    var state = window.smokeAiSliderState[id];
    var track = document.getElementById(id + "-track");
    var counter = document.getElementById(id + "-counter");
    var prevBtn = document.getElementById(id + "-prev");
    var nextBtn = document.getElementById(id + "-next");
    if (track) {
      var container = track.parentElement;
      var slideWidth = container ? container.offsetWidth : track.offsetWidth;
      track.style.transform = "translateX(-" + state.current * slideWidth + "px)";
    }
    if (counter) counter.textContent = state.current + 1 + "/" + state.total;
    if (prevBtn) prevBtn.style.opacity = state.current === 0 ? "0.3" : "1";
    if (nextBtn) nextBtn.style.opacity = state.current >= state.total - 1 ? "0.3" : "1";
  }
  window.smokeAiSliderPrev = function(id) {
    var state = window.smokeAiSliderState[id];
    if (!state || state.current <= 0) return;
    state.current--;
    _smokeAiSlideMove(id);
  };
  window.smokeAiSliderNext = function(id) {
    var state = window.smokeAiSliderState[id];
    if (!state || state.current >= state.total - 1) return;
    state.current++;
    _smokeAiSlideMove(id);
  };
  window.smokeAiSliderTouchStart = function(event, id) {
    if (!window.smokeAiSliderState[id]) window.smokeAiSliderState[id] = { current: 0, total: 1 };
    window.smokeAiSliderState[id].touchStartX = event.touches[0].clientX;
  };
  window.smokeAiSliderTouchEnd = function(event, id) {
    var state = window.smokeAiSliderState[id];
    if (!state || state.touchStartX === void 0) return;
    var diff = state.touchStartX - event.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) window.smokeAiSliderNext(id);
      else window.smokeAiSliderPrev(id);
    }
  };
  function wrapInSlider(cardHtmlArray) {
    if (!cardHtmlArray || cardHtmlArray.length === 0) return "";
    var header = '<div style="display:flex;align-items:center;gap:6px;margin-bottom:8px;"><div style="width:2px;height:12px;background:#10b981;border-radius:2px;flex-shrink:0;"></div><span style="color:#a7b8b0;font-size:10px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;">Recommended Products</span>' + (cardHtmlArray.length > 1 ? '<span style="color:#4b6b5e;font-size:10px;">\u2014 swipe \u2192</span>' : "") + "</div>";
    var shelf = '<div class="smoke-ai-cards-scroll" style="display:flex;gap:10px;overflow-x:auto;padding-bottom:4px;-webkit-overflow-scrolling:touch;">' + cardHtmlArray.join("") + "</div>";
    return '<div style="margin-top:6px;">' + header + shelf + "</div>";
  }
  var _bagIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var _eyeIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>';
  function _buildCardImg(src, alt) {
    if (src) {
      return '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt || "") + `" style="width:100%;height:100%;object-fit:contain;padding:8px;display:block;" onerror="this.style.display='none'">`;
    }
    return '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:24px;">\u{1F33F}</div>';
  }
  function _buildEffectPills(effects) {
    if (!effects || effects.length === 0) return "";
    var html = '<div style="display:flex;gap:4px;overflow:hidden;margin-bottom:8px;">';
    effects.slice(0, 2).forEach(function(e) {
      html += '<span style="font-size:9px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.06);color:#9ca3af;padding:2px 6px;border-radius:999px;white-space:nowrap;">' + escapeHtml(String(e)) + "</span>";
    });
    return html + "</div>";
  }
  function _buildViewBtn(url, label) {
    var style = "display:inline-flex;align-items:center;justify-content:center;gap:4px;padding:6px 10px;border-radius:8px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.08);color:#9ca3af;font-size:11px;font-weight:500;text-decoration:none;cursor:pointer;";
    var text = label || "View";
    if (url && url !== "#" && url !== window.location.pathname) {
      return '<a href="' + escapeHtml(url) + '" target="_blank" style="' + style + '">' + _eyeIcon + "&nbsp;" + text + "</a>";
    }
    return '<a href="' + escapeHtml(url || "#") + '" style="' + style + '">' + _eyeIcon + "&nbsp;" + text + "</a>";
  }
  var _plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:block;"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var _checkIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:block;"><polyline points="20 6 9 17 4 12"/></svg>';
  var _xIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:block;"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var _spinIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" style="display:block;animation:smokeSpin 0.7s linear infinite;"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';
  var _addBtnStyle = "background:#10b981;border:none;border-radius:9px;width:32px;height:32px;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 3px 10px rgba(16,185,129,0.35);padding:0;flex-shrink:0;";
  function _setBtnIcon(btn, icon, bg) {
    btn.innerHTML = icon;
    btn.style.background = bg || "#10b981";
  }
  function _buildCardHtml(opts) {
    var tagText = opts.subtext ? opts.subtext.split("\xB7")[0].split("\xB7")[0].trim() : "";
    var tagPill = tagText ? '<span style="background:rgba(16,185,129,0.15);color:#10b981;font-size:9px;font-weight:800;padding:2px 7px;border-radius:4px;letter-spacing:0.05em;display:inline-block;">' + escapeHtml(tagText) + "</span>" : "";
    var priceHtml = opts.priceStr ? '<span style="color:#7ed957;font-weight:800;font-size:16px;letter-spacing:-0.02em;">' + escapeHtml(String(opts.priceStr)) + "</span>" : "<span></span>";
    var addBtn = "";
    if (opts.cartBtn) {
      addBtn = opts.cartBtn.replace(/style="[^"]*"/, 'style="' + _addBtnStyle + '"');
      addBtn = addBtn.replace(/>[\s\S]*?<\/button>/, ">" + _plusIcon + "</button>");
    } else if (opts.viewUrl && opts.viewUrl !== "#") {
      addBtn = '<a href="' + escapeHtml(opts.viewUrl) + '" style="' + _addBtnStyle + 'text-decoration:none;">' + _plusIcon + "</a>";
    }
    var noteText = "";
    if (opts.subtext && opts.subtext.indexOf("\xB7") !== -1) {
      noteText = opts.subtext.split("\xB7").slice(1).join("\xB7").trim();
    } else if (opts.effects && opts.effects.length > 0) {
      noteText = String(opts.effects[0]);
    }
    var noteHtml = noteText ? '<p style="color:#a7b8b0;font-size:11px;margin:0 0 9px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(noteText) + "</p>" : '<div style="margin-bottom:9px;"></div>';
    var viewBtnHtml = "";
    if (opts.viewUrl && opts.viewUrl !== "#") {
      viewBtnHtml = '<a href="' + escapeHtml(opts.viewUrl) + '" target="_blank" class="smoke-ai-view-btn">View Product</a>';
    }
    return '<div class="smoke-ai-product-card"><div class="smoke-ai-card-img-box">' + opts.imageHtml + '</div><div style="padding:10px 11px 12px;">' + tagPill + '<p style="color:#f0fdf4;font-weight:700;font-size:13px;margin:6px 0 2px;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(opts.title || "") + "</p>" + noteHtml + '<div style="display:flex;align-items:center;justify-content:space-between;">' + priceHtml + addBtn + "</div>" + viewBtnHtml + "</div></div>";
  }
  function createProductCard() {
    if (!productInfo.title) return "";
    const productUrl = productInfo.handle ? "/products/" + productInfo.handle : window.location.pathname;
    const cartBtnId = "smoke-ai-cart-btn-" + Date.now();
    const showAddToCart = settings.showAddToCart !== false && isShopifyStore() && productInfo.variantId;
    const cartBtn = showAddToCart ? '<button class="smoke-ai-add-cart-btn" id="' + cartBtnId + '" data-smoke-ai-cart="true" data-variant-id="' + escapeHtml(productInfo.variantId) + '" style="flex:1;display:flex;align-items:center;justify-content:center;gap:4px;">' + _bagIcon + " Add to Cart</button>" : "";
    const subtext = productInfo.type || productInfo.vendor || "Cannabis Product";
    return _buildCardHtml({
      imageHtml: _buildCardImg(productInfo.image, productInfo.title),
      title: productInfo.title,
      priceStr: productInfo.price || "",
      subtext,
      effects: [],
      cartBtn,
      viewUrl: productUrl,
      viewLabel: "View"
    });
  }
  function createCatalogProductCard(product) {
    if (!product || !product.title) return "";
    const productUrl = product.url || (product.handle ? "/products/" + product.handle : "#");
    const cartBtnId = "smoke-ai-cart-btn-" + Date.now() + "-" + Math.random().toString(36).substr(2, 5);
    const cartEnabled = settings.showAddToCart !== false;
    const onShopify = isShopifyStore();
    const isB2BMode = cartEnabled && settings.inventoryOnly;
    var cartBtn = "";
    const btnStyle = "flex:1;display:inline-flex;align-items:center;justify-content:center;gap:4px;padding:6px 8px;border-radius:8px;background:#059669;color:#fff;font-size:11px;font-weight:600;border:none;cursor:pointer;";
    if (cartEnabled && onShopify && product.variantId) {
      cartBtn = '<button id="' + cartBtnId + '" data-smoke-ai-cart="true" data-variant-id="' + escapeHtml(String(product.variantId)) + '" style="' + btnStyle + '">' + _bagIcon + "&nbsp;Add to Cart</button>";
    } else if (cartEnabled && onShopify && product.handle) {
      cartBtn = '<button id="' + cartBtnId + '" data-smoke-ai-cart="true" data-handle="' + escapeHtml(product.handle) + '" style="' + btnStyle + '">' + _bagIcon + "&nbsp;Add to Cart</button>";
    } else if (isB2BMode && product.externalId) {
      cartBtn = '<button id="' + cartBtnId + '" data-smoke-ai-blaze-cart="true" data-external-id="' + escapeHtml(String(product.externalId)) + '" data-product-title="' + escapeHtml(product.title) + '" style="' + btnStyle + '">' + _bagIcon + "&nbsp;Add to Cart</button>";
    } else if (isB2BMode) {
      cartBtn = '<button id="' + cartBtnId + '" data-smoke-ai-cart="true" data-b2b-product="' + escapeHtml(product.title) + '" data-product-id="' + (product.id || "") + '" data-price="' + (product.price || 0) + '" style="' + btnStyle + '">' + _bagIcon + "&nbsp;Add to Cart</button>";
    }
    const viewLabel = isB2BMode && !onShopify && productUrl !== "#" ? "Shop Now" : "View";
    const subtext = product.type || product.vendor || "";
    const priceStr = product.price ? "$" + String(product.price) : "";
    return _buildCardHtml({
      imageHtml: _buildCardImg(product.image, product.title),
      title: product.title,
      priceStr,
      subtext,
      effects: product.effects || [],
      cartBtn,
      viewUrl: productUrl,
      viewLabel
    });
  }
  function createRecommendedProductCards(recommendedProducts) {
    recommendedProducts = (recommendedProducts || []).filter(isVisibleStoreProduct);
    console.log("\u{1F3B4} createRecommendedProductCards called:", {
      count: (recommendedProducts == null ? void 0 : recommendedProducts.length) || 0,
      storeProductsCount: storeProducts.length,
      isShopify: isShopifyStore()
    });
    if (!recommendedProducts || recommendedProducts.length === 0) return "";
    var cardItems = [];
    recommendedProducts.slice(0, 4).forEach(function(product, index) {
      let matchedProduct = null;
      if (storeProducts.length > 0) {
        const titleLower = (product.title || "").toLowerCase();
        matchedProduct = storeProducts.find((p) => p.title.toLowerCase() === titleLower);
        if (!matchedProduct) {
          matchedProduct = storeProducts.find(
            (p) => p.title.toLowerCase().includes(titleLower) || titleLower.includes(p.title.toLowerCase())
          );
        }
        console.log("\u{1F50D} Product match:", {
          aiTitle: product.title,
          matched: !!matchedProduct,
          matchedHandle: matchedProduct == null ? void 0 : matchedProduct.handle
        });
        if (!matchedProduct) {
          console.warn("[SmokeAI] Skipping card for unverified product:", product.title);
          return;
        }
      }
      const handle = (matchedProduct == null ? void 0 : matchedProduct.handle) || product.handle || "";
      const variantId = (matchedProduct == null ? void 0 : matchedProduct.variantId) || product.variantId || "";
      const liveImage = (matchedProduct == null ? void 0 : matchedProduct.image) || product.image || "";
      const livePrice = (matchedProduct == null ? void 0 : matchedProduct.price) || product.price || "";
      console.log("\u{1F3B4} Product card data:", { title: product.title, handle, variantId });
      const productUrl = handle ? "/products/" + handle : product.url || "#";
      const cartBtnId = "api-cart-btn-" + Date.now() + "-" + index;
      const productType = product.type || product.category || "";
      const thc = product.thc || "";
      const subtext = thc ? productType ? productType + " \xB7 THC " + thc : "THC " + thc : productType || "";
      const priceStr = livePrice ? "$" + String(livePrice) : product.price ? "$" + String(product.price) : "";
      const btnStyle = "flex:1;display:inline-flex;align-items:center;justify-content:center;gap:4px;padding:6px 8px;border-radius:8px;background:#059669;color:#fff;font-size:11px;font-weight:600;border:none;cursor:pointer;";
      const cartBtn = variantId ? '<button id="' + cartBtnId + '" data-smoke-ai-cart="true" data-variant-id="' + escapeHtml(String(variantId)) + '" style="' + btnStyle + '">' + _bagIcon + "&nbsp;Add to Cart</button>" : handle ? '<button id="' + cartBtnId + '" data-smoke-ai-cart="true" data-handle="' + escapeHtml(handle) + '" style="' + btnStyle + '">' + _bagIcon + "&nbsp;Add to Cart</button>" : "";
      cardItems.push(_buildCardHtml({
        imageHtml: _buildCardImg(liveImage || product.image, product.title),
        matchPct: product.match || null,
        title: (matchedProduct == null ? void 0 : matchedProduct.title) || product.title,
        // use exact store title
        priceStr,
        subtext,
        effects: product.effects || [],
        cartBtn,
        viewUrl: productUrl,
        viewLabel: "View"
      }));
    });
    return wrapInSlider(cardItems);
  }
  function findAndCreateProductCards(aiResponse) {
    if (storeProducts.length === 0) return "";
    const responseLower = aiResponse.toLowerCase();
    const matchedProducts = [];
    const seenIds = /* @__PURE__ */ new Set();
    var genericWords = /* @__PURE__ */ new Set([
      "indica",
      "sativa",
      "hybrid",
      "flower",
      "vape",
      "cart",
      "cartridge",
      "edible",
      "gummies",
      "gummy",
      "concentrate",
      "tincture",
      "rosin",
      "resin",
      "hash",
      "thc",
      "cbd",
      "cbn",
      "cbg",
      "cbc",
      "thca",
      "pack",
      "gram",
      "ounce",
      "dose",
      "drops",
      "spray",
      "distillate",
      "extract",
      "wax",
      "shatter",
      "infused",
      "live",
      "rosin",
      "badder",
      "sauce",
      "sugar",
      "crumble",
      "diamonds",
      "trim",
      "with",
      "from",
      "that",
      "this",
      "your",
      "have",
      "will",
      "also",
      "been",
      "more",
      "some",
      "10pk",
      "10mg",
      "1g",
      "3g",
      "7g",
      "14g",
      "28g",
      "0.5g",
      "2g",
      "1.5g",
      "pickup",
      "delivery",
      "today",
      "stock",
      "current",
      "available"
    ]);
    var boldPhrases = [];
    var boldRegex = /\*\*([^*]{3,60})\*\*/g;
    var bm;
    while ((bm = boldRegex.exec(aiResponse)) !== null) {
      boldPhrases.push(bm[1].toLowerCase().trim());
    }
    function titleTokens(title) {
      return (title || "").toLowerCase().split(/[\s|,\-\:]+/).map(function(t) {
        return t.replace(/[^a-z0-9]/g, "");
      }).filter(function(t) {
        return t.length > 2 && !genericWords.has(t);
      });
    }
    function phraseScore(product, phrase) {
      var tokens2 = titleTokens(product.title);
      var phraseWords = phrase.split(/[\s\-]+/).map(function(w) {
        return w.replace(/[^a-z0-9]/g, "");
      }).filter(function(w) {
        return w.length > 2 && !genericWords.has(w);
      });
      if (phraseWords.length === 0 || tokens2.length === 0) return 0;
      var recallHits = phraseWords.filter(function(pw) {
        return tokens2.some(function(t) {
          return t.includes(pw) || pw.includes(t);
        });
      }).length;
      var precisionHits = tokens2.filter(function(t) {
        return phraseWords.some(function(pw) {
          return t.includes(pw) || pw.includes(t);
        });
      }).length;
      var recall = recallHits / phraseWords.length;
      var precision = precisionHits / tokens2.length;
      if (recall + precision === 0) return 0;
      return 2 * recall * precision / (recall + precision);
    }
    console.log("[SmokeAI] \u{1F50D} Product matching \u2014 bold phrases extracted:", boldPhrases);
    console.log("[SmokeAI] \u{1F50D} Store products available:", storeProducts.length);
    if (boldPhrases.length > 0) {
      for (var i = 0; i < storeProducts.length && matchedProducts.length < 4; i++) {
        var p = storeProducts[i];
        if (seenIds.has(p.id)) continue;
        var bestScore = 0;
        var bestPhrase = "";
        for (var b = 0; b < boldPhrases.length; b++) {
          var score = phraseScore(p, boldPhrases[b]);
          if (score > bestScore) {
            bestScore = score;
            bestPhrase = boldPhrases[b];
          }
        }
        console.log("[SmokeAI]   product:", p.title, "\u2192 best bold match:", bestPhrase, "F1:", bestScore.toFixed(2));
        if (bestScore >= 0.65) {
          console.log("[SmokeAI]   \u2705 MATCHED via bold phrase");
          matchedProducts.push(p);
          seenIds.add(p.id);
        }
      }
    }
    console.log("[SmokeAI] After bold matching:", matchedProducts.length, "products matched");
    var _refusalSignals = [
      "i can't recommend",
      "i cannot recommend",
      "i need to be straightforward",
      "not recommended",
      "safety concerns",
      "no fda-approved",
      "consult a vet",
      "speak with a vet",
      "consult your veterinarian",
      "clinical trials",
      "not established"
    ];
    var _isRefusal = _refusalSignals.some(function(sig) {
      return responseLower.includes(sig);
    });
    if (matchedProducts.length === 0 && !_isRefusal) {
      for (var i = 0; i < storeProducts.length && matchedProducts.length < 4; i++) {
        var p = storeProducts[i];
        if (seenIds.has(p.id)) continue;
        var tokens = titleTokens(p.title);
        var hits = tokens.filter(function(t) {
          return t.length > 3 && responseLower.includes(t);
        });
        if (hits.length >= 2) {
          console.log("[SmokeAI]   \u2705 MATCHED via multi-word:", p.title, "\u2014 words:", hits);
          matchedProducts.push(p);
          seenIds.add(p.id);
        }
      }
    }
    if (matchedProducts.length === 0 && settings.inventoryOnly && storeProducts.length > 0) {
      var effectKeywords = ["relax", "sleep", "pain", "anxiety", "stress", "energy", "focus", "creative", "euphoria", "calm", "sedating", "uplifting"];
      var categoryKeywords = ["flower", "edible", "gummy", "vape", "concentrate", "tincture", "hash", "rosin"];
      var scoredProds = storeProducts.map(function(prod) {
        var score2 = 0;
        var productText = ((prod.title || "") + " " + (prod.description || "") + " " + (prod.type || "")).toLowerCase();
        effectKeywords.forEach(function(kw) {
          if (responseLower.includes(kw) && productText.includes(kw)) score2 += 3;
        });
        categoryKeywords.forEach(function(kw) {
          if (responseLower.includes(kw) && productText.includes(kw)) score2 += 2;
        });
        return { prod, score: score2 };
      });
      var topProds = scoredProds.filter(function(x) {
        return x.score > 0;
      }).sort(function(a, b2) {
        return b2.score - a.score;
      }).slice(0, 4);
      if (topProds.length > 0) {
        topProds.forEach(function(x) {
          matchedProducts.push(x.prod);
        });
      }
    }
    if (matchedProducts.length === 0) return "";
    return wrapInSlider(matchedProducts.map(function(product) {
      return createCatalogProductCard(product);
    }));
  }
  function shouldShowProductCard(question) {
    if (!productInfo.title) return false;
    return true;
  }
  async function handleSend() {
    const input = document.getElementById("smoke-ai-input");
    const sendBtn = document.getElementById("smoke-ai-send");
    if (!input || !sendBtn) return;
    const question = input.value.trim();
    if (!question) return;
    if (!termsAccepted) {
      pendingQuestion = question;
      input.value = "";
      showTermsPopup();
      return;
    }
    input.value = "";
    processQuestion(question);
  }
  function _appendProductCardsToStreamBubble(responseText) {
    var showProductCards = settings.inventoryOnly || isShopifyStore() && storeProducts.length > 0 || storeProducts.length > 0;
    var cards = "";
    if (showProductCards && storeProducts.length > 0) {
      cards = findAndCreateProductCards(responseText);
    } else if (!showProductCards && shouldShowProductCard(responseText)) {
      cards = createProductCard();
    }
    if (cards && _activeStreamBubble) {
      _activeStreamBubble.innerHTML += cards;
      setTimeout(_initSliderWidths, 50);
      var msg = document.getElementById("smoke-ai-streaming-msg");
      if (msg) {
        setTimeout(function() {
          try {
            msg.scrollIntoView({ behavior: "smooth", block: "start" });
          } catch (_) {
          }
        }, 120);
      }
    }
    _activeStreamBubble = null;
  }
  var _questionInFlight = false;
  async function processQuestion(question) {
    if (_questionInFlight) return;
    _questionInFlight = true;
    var sendBtn = document.getElementById("smoke-ai-send");
    addMessage(question, false, false);
    addMessage("", true, true);
    if (sendBtn) sendBtn.disabled = true;
    var waitingNotice = setTimeout(function() {
      var loadingText = document.querySelector("#smoke-ai-loading .smoke-ai-loading-text");
      if (loadingText) loadingText.textContent = "Still waiting for Smoke AI\u2026";
    }, 8e3);
    try {
      try {
        var streamedText = await askAIStream(question);
        var cleanedStream = cleanResponseText(streamedText) || streamedText || "";
        if (_activeStreamBubble) _activeStreamBubble.innerHTML = formatResponse(cleanedStream);
        _appendProductCardsToStreamBubble(cleanedStream);
        if (quotaInfo.isB2B && quotaInfo.questionsRemaining > 0) {
          quotaInfo.questionsRemaining--;
          quotaInfo.questionsUsedThisMonth++;
          localStorage.setItem(QUOTA_KEY, JSON.stringify(quotaInfo));
          updateQuotaStatus();
        }
      } catch (streamErr) {
        console.warn("[SmokeAI] Stream failed, falling back to regular API:", streamErr.message);
        if (_activeStreamBubble) {
          try {
            var _partialWrap = _activeStreamBubble.closest(".smoke-ai-message") || _activeStreamBubble.parentNode;
            if (_partialWrap && _partialWrap.parentNode) _partialWrap.parentNode.removeChild(_partialWrap);
          } catch (e) {
          }
        }
        _activeStreamBubble = null;
        removeLoading();
        if (streamErr.isDemoLimit !== void 0 || streamErr.requiresCredits !== void 0) {
          throw streamErr;
        }
        if (streamErr.noAutomaticRetry) throw streamErr;
        try {
          addMessage("", true, true);
          var result = await askAI(question);
          removeLoading();
          var response = cleanResponseText(result.response) || "No response received.";
          if (result.recommendations && result.recommendations.length > 0) {
            response += "<br><br><strong>\u{1F4A1} Recommendations:</strong><ul>";
            result.recommendations.forEach(function(rec) {
              response += "<li>" + escapeHtml(rec) + "</li>";
            });
            response += "</ul>";
          }
          if (result.partnerProductData && result.partnerProductData.length > 0 && storeProducts.length === 0) {
            storeProducts = result.partnerProductData.map(function(p) {
              return {
                id: p.id,
                title: p.name,
                type: p.category || "",
                image: p.imageUrl || null,
                price: p.price || null,
                url: p.productUrl || null,
                externalId: p.externalId || null,
                inStock: p.inStock !== false
              };
            });
          }
          var showCards = settings.inventoryOnly || isShopifyStore() && storeProducts.length > 0 || storeProducts.length > 0;
          if (showCards) {
            if (result.recommendedProducts && result.recommendedProducts.length > 0) {
              response += createRecommendedProductCards(result.recommendedProducts);
            } else if (storeProducts.length > 0) {
              var catalogCards = findAndCreateProductCards(cleanResponseText(result.response) || "");
              if (catalogCards) response += catalogCards;
            }
          } else if (shouldShowProductCard(question)) {
            response += createProductCard();
          }
          addMessage(response, true, false);
          if (quotaInfo.isB2B && quotaInfo.questionsRemaining > 0) {
            quotaInfo.questionsRemaining--;
            quotaInfo.questionsUsedThisMonth++;
            localStorage.setItem(QUOTA_KEY, JSON.stringify(quotaInfo));
            updateQuotaStatus();
          }
        } catch (fallbackErr) {
          console.error("Smoke AI fallback error:", fallbackErr);
          removeLoading();
          if (fallbackErr.message && (fallbackErr.message.includes("quota") || fallbackErr.message.includes("Quota"))) {
            quotaInfo.questionsRemaining = 0;
            updateQuotaStatus();
            showError('Monthly question quota exceeded. <a href="https://smokeai.chat/smoke-ai/business#pricing" target="_blank" style="color: #10b981;">Upgrade your plan</a> to continue.');
          } else {
            showError("Unable to get AI response. Please try again. (" + fallbackErr.message + ")", question);
          }
        }
      }
    } catch (err) {
      console.error("Smoke AI error:", err);
      _activeStreamBubble = null;
      removeLoading();
      if (err.message && (err.message.includes("quota") || err.message.includes("Quota") || err.message.includes("Limit"))) {
        quotaInfo.questionsRemaining = 0;
        updateQuotaStatus();
        showError('Monthly question quota exceeded. <a href="https://smokeai.chat/smoke-ai/business#pricing" target="_blank" style="color: #10b981;">Upgrade your plan</a> to continue.');
      } else {
        showError("Unable to get AI response. Please try again. (" + err.message + ")", question);
      }
    } finally {
      clearTimeout(waitingNotice);
      removeLoading();
      _questionInFlight = false;
      if (sendBtn) sendBtn.disabled = false;
    }
  }
  function shouldShow() {
    if (settings.showOnAllProducts) return true;
    const keywords = ["cannabis", "cbd", "hemp", "thc", "marijuana", "weed", "flower", "strain"];
    const type = (productInfo.type || "").toLowerCase();
    const title = (productInfo.title || "").toLowerCase();
    return keywords.some(function(kw) {
      return type.includes(kw) || title.includes(kw);
    });
  }
  function isAgeGateVisible() {
    if (localStorage.getItem("wc_age_v2")) return false;
    var wcGate = document.getElementById("wc-agegate");
    if (wcGate) {
      var cs = window.getComputedStyle(wcGate);
      return cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity || "1") > 0;
    }
    var selectors = [
      "#age-gate",
      ".age-gate",
      "#age-verification",
      ".age-verification",
      "[data-age-gate]",
      "[data-age-verification]",
      ".age-check",
      "#age-check",
      ".age-gate-overlay",
      ".age-gate-wrapper",
      ".age-gate__overlay",
      ".age-gate-modal",
      "#AgeGate",
      '[class*="age-gate"]',
      '[id*="age-gate"]',
      '[class*="age-verification"]',
      '[id*="age-verification"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var cs = window.getComputedStyle(el);
        if (cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity) > 0) return true;
      }
    }
    return false;
  }
  function startAgeGateWatch() {
    var widget = document.getElementById("smoke-ai-widget");
    if (!widget) return;
    var TEASER_SHOWN_KEY = "smoke_ai_teaser_shown";
    var GATE_SEEN_KEY = "smoke_ai_gate_seen";
    if (localStorage.getItem("wc_age_v2")) {
      sessionStorage.removeItem(GATE_SEEN_KEY);
    }
    var gateSeen = false;
    var revealed = false;
    widget.style.opacity = "0";
    widget.style.pointerEvents = "none";
    widget.style.transition = "opacity 0.45s ease";
    function hideRings() {
      var rings = document.querySelectorAll(".smoke-ai-ring");
      for (var i = 0; i < rings.length; i++) rings[i].style.display = "none";
    }
    function revealWidget(showTeaser) {
      if (revealed) return;
      revealed = true;
      widget.style.opacity = "1";
      widget.style.pointerEvents = "";
      var hasThemeWidget = !!window.__wcSaiThemeWidget;
      if (showTeaser && !hasThemeWidget && !localStorage.getItem(TEASER_SHOWN_KEY)) {
        localStorage.setItem(TEASER_SHOWN_KEY, "1");
        setTimeout(showTeaserPopup, 1200);
      } else {
        hideRings();
      }
    }
    if (localStorage.getItem(TEASER_SHOWN_KEY)) {
      widget.style.transition = "none";
      hideRings();
      revealWidget(false);
      return;
    }
    if (sessionStorage.getItem(GATE_SEEN_KEY)) {
      sessionStorage.removeItem(GATE_SEEN_KEY);
      setTimeout(function() {
        revealWidget(true);
      }, 300);
      return;
    }
    var observer = new MutationObserver(function() {
      if (isAgeGateVisible()) {
        gateSeen = true;
        revealed = false;
        widget.style.opacity = "0";
        widget.style.pointerEvents = "none";
        sessionStorage.setItem(GATE_SEEN_KEY, "1");
      } else if (gateSeen && !revealed) {
        observer.disconnect();
        sessionStorage.removeItem(GATE_SEEN_KEY);
        revealWidget(true);
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class", "hidden"]
    });
    setTimeout(function() {
      if (isAgeGateVisible()) {
        gateSeen = true;
        sessionStorage.setItem(GATE_SEEN_KEY, "1");
      } else if (!gateSeen) {
        observer.disconnect();
        revealWidget(false);
      }
    }, 300);
  }
  async function init() {
    if (window.__smokeAIInit && !document.getElementById("smoke-ai-widget") && !document.getElementById("smoke-ai-modal")) {
      window.__smokeAIInit = false;
    }
    if (document.getElementById("smoke-ai-widget") || document.getElementById("smoke-ai-modal") || window.__smokeAIInit) {
      console.log("Smoke AI: Already initialized, skipping duplicate init");
      return;
    }
    window.__smokeAIInit = true;
    if (!shouldShow()) {
      console.log("Smoke AI: Not showing on this page");
      return;
    }
    createStyles();
    if (!settings.isInline) {
      createButton();
      if (IS_WEEDCOMMERCE_DOMAIN) startAgeGateWatch();
    }
    createModal();
    setupCartEventDelegation();
    initAuth().catch(function(e) {
      console.warn("Auth init error:", e);
    });
    checkHealth().then(function(ok) {
      if (ok) {
        updateQuotaStatus();
      } else {
        const status = document.getElementById("smoke-ai-status");
        if (status) {
          status.innerHTML = "\u26A0\uFE0F Limited mode - Try again shortly";
          status.style.color = "#f59e0b";
        }
      }
    });
    console.log("\u2705 Smoke AI Widget ready");
  }
  function setupCartEventDelegation() {
    const widgetContainer = document.getElementById("smoke-ai-modal");
    if (!widgetContainer) {
      console.warn("Widget container not found for cart delegation");
      return;
    }
    widgetContainer.addEventListener("click", function(e) {
      const blazeBtn = e.target.closest("[data-smoke-ai-blaze-cart]");
      if (blazeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const externalId = blazeBtn.getAttribute("data-external-id");
        const productTitle = blazeBtn.getAttribute("data-product-title") || "this product";
        if (!externalId) return;
        _setBtnIcon(blazeBtn, _spinIcon);
        blazeBtn.disabled = true;
        const partnerId = config.partnerId || settings.partnerId;
        const apiKey = config.apiKey || settings.apiKey || "";
        fetch("/api/blaze/cart/add-to-cart", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            partnerId,
            apiKey,
            productExternalId: externalId,
            quantity: 1
          })
        }).then(function(r) {
          return r.json();
        }).then(function(data) {
          if (data.redirectUrl) {
            _setBtnIcon(blazeBtn, _checkIcon, "#16a34a");
            window.open(data.redirectUrl, "_blank");
            setTimeout(function() {
              _setBtnIcon(blazeBtn, _plusIcon);
              blazeBtn.disabled = false;
            }, 3e3);
          } else {
            _setBtnIcon(blazeBtn, _checkIcon, "#16a34a");
            setTimeout(function() {
              _setBtnIcon(blazeBtn, _plusIcon);
              blazeBtn.disabled = false;
            }, 2e3);
          }
        }).catch(function(err) {
          console.warn("Blaze cart error:", err);
          _setBtnIcon(blazeBtn, _plusIcon);
          blazeBtn.disabled = false;
        });
        return;
      }
      const btn = e.target.closest("[data-smoke-ai-cart]");
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.getAttribute("data-variant-id");
        const handle = btn.getAttribute("data-handle");
        const b2bProduct = btn.getAttribute("data-b2b-product");
        const buttonId = btn.id;
        console.log("\u{1F6D2} Widget cart click:", { variantId, handle, b2bProduct, buttonId, isB2B: settings.inventoryOnly });
        if (variantId) {
          window.smokeAIAddToCart(variantId, buttonId);
        } else if (handle) {
          window.smokeAIAddToCartByHandle(handle, buttonId);
        } else if (b2bProduct && settings.inventoryOnly) {
          window.dispatchEvent(new CustomEvent("smokeAIAddToCart", {
            detail: {
              product: b2bProduct,
              id: btn.getAttribute("data-product-id") || "",
              price: parseFloat(btn.getAttribute("data-price")) || 0
            }
          }));
          _setBtnIcon(btn, _checkIcon, "#16a34a");
          setTimeout(function() {
            _setBtnIcon(btn, _plusIcon);
            btn.disabled = false;
          }, 2e3);
        }
      }
    }, true);
    console.log("\u{1F6D2} Cart event delegation registered on widget container");
  }
  window.SmokeAI = {
    open: openModal,
    close: closeModal,
    ask: handleSend,
    version: "4.0"
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
(function() {
  var style = document.createElement("style");
  style.id = "smoke-ai-store-overrides";
  style.textContent = `
    /* \u2500\u2500 Store widget: desktop floating card dimensions \u2500\u2500 */
    @media (min-width: 481px) {
      .smoke-ai-modal.bubble-mode .smoke-ai-modal-content {
        width: 400px;
        height: 580px;
        bottom: 100px;
        right: 24px;
      }
    }

    /* \u2500\u2500 Store widget: mobile full-screen \u2500\u2500 */
    @media (max-width: 480px) {
      .smoke-ai-modal.bubble-mode .smoke-ai-modal-content {
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        width: 100%; max-width: 100%;
        height: auto; max-height: none;
        border-radius: 0;
        overflow: hidden;
      }
      .smoke-ai-modal.bubble-mode .smoke-ai-body {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .smoke-ai-modal.bubble-mode .smoke-ai-messages {
        flex: 1;
        max-height: none;
        min-height: 0;
        overflow-y: auto;
      }
      .smoke-ai-modal.bubble-mode .smoke-ai-input-group { flex-shrink: 0; }
      .smoke-ai-modal.bubble-mode .smoke-ai-disclaimer { flex-shrink: 0; }
    }
  `;
  document.head.appendChild(style);
})();
